<template>
  <!-- 客户管理 -->
  <div class="saleCustomerManagement">
    <div class="public_Spacing customerManagementPC">
      <div class="pulbic_oparetionBlock">
        <div class="public_criteriaRange customerManagementPC-select">
          <div class="public_oparetionBlock_Menu">
            <label class="public_lbSty" style="width: 130px;">客户名称/昵称：</label>
            <div class="el-select public_optionSty">
              <div class="el-input el-input--suffix">
                <input style="padding-right: 10px;" class="el-input__inner pulic_carNumber" type="text"
                  placeholder="请输入客户名称/昵称" v-model="cusQueryName" />
              </div>
            </div>
          </div>
          <div class="public_oparetionBlock_Menu">
            <label class="public_lbSty">手机号：</label>
            <div class="el-select public_optionSty">
              <div class="el-input el-input--suffix">
                <input maxlength="11" class="el-input__inner pulic_carNumber" type="text" placeholder="请输入手机号"
                  v-model="cusQueryiphone" />
              </div>
            </div>
          </div>
          <div class="public_oparetionBlock_Menu">
            <label class="public_lbSty">客户等级：</label>
            <el-select class="public_optionSty dropDown_Define" v-model="khdj" @clear="clearFun" clearable
              placeholder="请选择">
              <el-option v-for="item in khdjOperation" :key="item.SETTB206CA00" :label="item.SETTB206CA01"
                :value="item.SETTB206CA00">
              </el-option>
            </el-select>
          </div>
          <div class="public_oparetionBlock_Menu">
            <label class="public_lbSty">客户星级：</label>
            <el-select class="public_optionSty dropDown_Define" v-model="khxj" placeholder="请选择">
              <el-option v-for="item in khxjOperation" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="public_oparetionBlock_Menu">
            <label class="public_lbSty">可用余额：</label>
            <el-select class="public_optionSty dropDown_Define" v-model="kyyepx" placeholder="请选择">
              <el-option v-for="item in kyyepxOperation" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="public_oparetionBlock_Menu">
            <label class="public_lbSty">授信客户：</label>
            <el-select class="public_optionSty dropDown_Define" clearable v-model="sxkh" placeholder="请选择">
              <el-option v-for="item in sxList" :key="item.ORMTB410ID" :label="item.ORMTB410CA00"
                :value="item.ORMTB410ID">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="customerManagementPC-btn public_operatBtn" style="margin-left: 0px;">
          <button class="public_saleWater_xinzeng pulic_cursor pulic_cursor"
            @click="queryWayTypeQuery(), (saleWaterDetails = true)" v-shiroHiden="solelist" id="充值类型">
            <i class="iconfont icon-chaxun"></i>充值类型
          </button>
          <el-button class="public_saleWater_chaxun" type="primary" v-shiroHiden="solelist" id="查询"
            @click="querycusList()">
            <i class="iconfont icon-chaxun"></i>查询
          </el-button>
          <el-button class="public_saleWater_xinzeng" type="primary" v-shiroHiden="solelist" id="新增" @click="cusADD">
            <i class="iconfont icon-tianjia1"></i>新增
          </el-button>
          <el-button class="public_saleWater_daochu" type="primary" v-if="preferentialType == 1" v-shiroHiden="solelist"
            id="客户等级管理" @click="; (customerManagement = true), customerManagementQuery()">
            客户等级管理
          </el-button>
          <!-- <el-button class="public_saleWater_chaxun" type="primary" v-shiroHiden="solelist" id="查询"
						@click="querycusList(1)">
						<i class="iconfont icon-chaxun"></i>查询全部
					</el-button> -->
          <el-button class="public_saleWater_xinzeng" type="primary" v-shiroHiden="solelist" id="等级冻结设置"
            @click="freezeSetClick()">
            <i class="iconfont icon-shezhi"></i>等级冻结设置
          </el-button>
          <el-button class="public_saleWater_xinzeng" type="primary" v-shiroHiden="solelist" id="账单记录"
            @click="billingRecordClick">账单记录
          </el-button>
          <!-- <el-button class="public_saleWater_quanping" type="primary" :disabled="quanpDisabled" @click="fullScreen">
						<i class="iconfont icon-tuichuquanping1"></i>全屏
					</el-button> -->
        </div>
      </div>
      <div class="customerManagementPC-table pulbic_oparetionBlock pulbic_table_container">
        <!-- @row-click="rowClick" -->
        <!-- :row-class-name="rowClassName" -->

        <!-- <RecycleScroller class="scroller" :items="tableData" :item-size="54" key-field="ORMTB410ID"> -->
        <!-- <template v-slot="{ item }"> -->
        <el-table :data="tableData" @sort-change="onSortChange" height="580" style="width: 100%" stripe
          class="public_tableColumn" :header-cell-style="{
            color: 'rgba(51,51,51,1)',
            background: 'rgba(184,227,255,1)',
            'font-weight': 'bold',
          }">
          <el-table-column prop="ORMTB410CA00" width="130" label="客户名称" fixed="left">
            <template slot-scope="scope">
              <p>
                <span>{{ scope.row.ORMTB410CA00 }}</span>
              </p>
              <p style="color: #999;">
                <span>{{ scope.row.ORMTB410CA02 }}</span>
              </p>
            </template>
          </el-table-column>
          <el-table-column prop="ORMTB410CA00" width="130" label="客户昵称" fixed="left">
            <template slot-scope="scope">
              <p>
                <span>{{ scope.row.ORMTB410CA10 }}</span>
                <img v-if="scope.row.creditStatus" src="../../../src/assets/images/orderStatistics/xin.png" alt=""
                  style="width: 20px;height: 20px;display: inline-block;vertical-align: middle;margin-left: 10px;" />
              </p>
            </template>
          </el-table-column>
          <el-table-column prop="ORMTB410CA00" label="客户身份" width="110">
            <template slot-scope="scope">
              <p style="color: #FFCC00;" v-if="scope.row.ORMTB410CB03 == '1'">
                <span>发单人</span>
              </p>
              <p style="color: #FF6600;" v-if="scope.row.ORMTB410CB04 == '1'">
                <span>车主</span>
              </p>
              <p v-else>
                <span>普通用户</span>
              </p>
            </template>
          </el-table-column>
          <el-table-column prop="ORMTB410CB10" label="运费结算方式" width="130">
            <template slot-scope="scope">
              <p>
                <span v-if="scope.row.ORMTB410CB10 == '0'">线上结算</span>
                <span v-if="scope.row.ORMTB410CB10 == '1'">线下结算</span>
              </p>
            </template>
          </el-table-column>

          <el-table-column v-if="userobj.pertb005.pertb005cb00 == 'CUS-1'" prop="ORMTB410CB10" label="发票状态" width="130">
            <template slot-scope="scope">
              <p>
                <span v-if="scope.row.ORMTB410CB18 == '0'">关闭</span>
                <span v-if="scope.row.ORMTB410CB18 == '1'">启用</span>
              </p>
            </template>
          </el-table-column>
          <el-table-column prop="ORMTB410CB24" label="延迟结算运费权限" width="160">
            <template slot-scope="scope">
              <p>
                <span v-if="scope.row.ORMTB410CB24 == '0'">关闭</span>
                <span v-if="scope.row.ORMTB410CB24 == '1'">开启</span>
              </p>
            </template>
          </el-table-column>
          <el-table-column v-if="userobj.pertb005.pertb005cb00 == 'CUS-1'" prop="ORMTB410CB10" label="收料权限" width="130">
            <template slot-scope="scope">
              <p>
                <span v-if="scope.row.ORMTB410CB21 == '0'">关闭</span>
                <span v-if="scope.row.ORMTB410CB21 == '1'">开启</span>
              </p>
            </template>
          </el-table-column>
          <el-table-column prop="ORMTB410CA03" sortable label="可用余额" width="130"></el-table-column>
          <el-table-column prop="ORMTB410CA04" sortable label="冻结金额" width="110"></el-table-column>
          <el-table-column prop="ORMTB410CA05" sortable label="可提现金额" width="200"></el-table-column>
          <el-table-column prop="ORMTB410CB26" label="可用运费" width="110"></el-table-column>
          <el-table-column prop="ORMTB410CB20" label="可提现运费" width="110"></el-table-column>
          <el-table-column label="已冻结运费" prop="ORMTB410CB27" width="130"></el-table-column>
          <el-table-column prop="ORMTB410CA07" label="可用能源金" width="110"></el-table-column>
          <el-table-column prop="ORMTB410CA11" label="可提现能源金" width="130"></el-table-column>
          <el-table-column label="已冻结能源金" prop="ORMTB410CA12" width="130"></el-table-column>
          <el-table-column v-if="preferentialType == 1" prop="ORMTB410CA06" sortable label="客户等级" width="110">
            <template slot-scope="scope">
              <p>
                <span>{{ scope.row.ORMTB410CA06Name }}</span>
              </p>
            </template>
          </el-table-column>
          <el-table-column prop="ORMTB410CB02" sortable label="客户星级" width="110">
            <template slot-scope="scope">
              <p v-if="scope.row.ORMTB410CB02 >= 1">
                <span>V{{ scope.row.ORMTB410CB02 }}</span>
              </p>
            </template>
          </el-table-column>
          <el-table-column prop="recharge" sortable label="累计充值" width="110"></el-table-column>
          <el-table-column prop="consume" sortable label="累计消费" width="110"></el-table-column>
          <el-table-column prop="withdraw" sortable label="累计提现" width="110"></el-table-column>
          <el-table-column prop="creditAmt" label="总授信额度" width="130"></el-table-column>
          <el-table-column prop="repayAmt" label="待还金额" width="130"></el-table-column>
          <el-table-column prop="usableAmt" label="授信可用余额" width="130"></el-table-column>
          <el-table-column prop="deditSum" label="累计违约金" width="130"></el-table-column>
          <el-table-column label="授信调整记录" width="130">
            <template slot-scope="scope">
              <el-button class="public_icon_qiyong public_icon_width public_icon_margin" size="small"
                v-shiroHiden="solelist" id="授信调整记录" @click="creditClick(scope.row)">查看
              </el-button>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="400" fixed="right">
            <template slot-scope="scope">
              <div class="customerManagementPC-table-btn">
                <!-- <el-button @click="updateUserStatus(scope.row)" v-if="scope.row.ORMTB410CB00==1"
									type="error" class="public_icon_xiugai public_icon_width" size="small"
									style="color: red!important">禁用</el-button>
								<el-button @click="updateUserStatus(scope.row)" v-if="scope.row.ORMTB410CB00==0"
									type="primary" class="public_icon_xiugai public_icon_width" size="small">启用
								</el-button>
								<el-button @click="updateUserLimitStatus(scope.row)" v-if="scope.row.ORMTB410CB01==0"
									type="error" class="public_icon_xiugai public_icon_width" size="small"
									style="color: red!important">限制下单</el-button>
								<el-button @click="updateUserLimitStatus(scope.row)" v-if="scope.row.ORMTB410CB01==1"
									type="primary" class="public_icon_xiugai public_icon_width" size="small">解除限制
								</el-button> -->

                <el-dropdown>
                  <span class="el-dropdown-link public_icon_qiyong">
                    财务<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                      <el-button class="public_icon_chongzhi public_icon_width public_icon_margin" type="primary"
                        size="small" @click="czClick(scope.row)" v-shiroHiden="solelist" id="充值">充值</el-button>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <el-button class="public_icon_hongchongred public_icon_width public_icon_margin" type="danger"
                        size="small" @click="HCclick(scope.row)" id="红冲">红冲
                      </el-button>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <el-button class="public_icon_chongzhi  public_icon_margin recharge-discount-width" type="primary"
                        size="small" @click="CZrecordClick(scope.row)" v-shiroHiden="solelist"
                        id="充值记录">充值优惠记录</el-button>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>

                <el-button type="primary" class="public_icon_xiugai public_icon_width" v-shiroHiden="solelist" id="修改"
                  size="small" @click="upuserClick(scope.row)">修改
                </el-button>
                <el-dropdown style="padding-left: 20px;" v-shiroHiden="solelist" id="设置">
                  <span class="el-dropdown-link public_icon_qiyong">
                    设置<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown" style="padding-right:20px;">
                    <el-dropdown-item>
                      <el-button @click="updateUserLimitStatus(scope.row)" v-if="scope.row.ORMTB410CB01 == 0"
                        type="error" class="public_icon_xiugai public_icon_width" size="small"
                        style="color: red!important">限制下单</el-button>
                      <el-button @click="updateUserLimitStatus(scope.row)" v-if="scope.row.ORMTB410CB01 == 1"
                        type="primary" class="public_icon_xiugai public_icon_width" size="small">解除限制
                      </el-button>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <el-button @click="updateUserStatus(scope.row)" v-if="scope.row.ORMTB410CB00 == 1" type="error"
                        class="public_icon_xiugai public_icon_width" size="small"
                        style="color: red!important">禁用</el-button>
                      <el-button @click="updateUserStatus(scope.row)" v-if="scope.row.ORMTB410CB00 == 0" type="primary"
                        class="public_icon_xiugai public_icon_width" size="small">启用
                      </el-button>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <el-button type="primary" style="color: red!important"
                        class="public_icon_xiugai public_icon_width" size="small"
                        @click="upDJSetuserClick(scope.row)">下单冻结设置
                      </el-button>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <el-button @click="updateYfStatus(scope.row)" v-if="scope.row.ORMTB410CB10 == 0" type="error"
                        class="public_icon_xiugai public_icon_width" size="small"
                        style="color: red!important">关闭线上结算</el-button>
                      <el-button @click="updateYfStatus(scope.row)" v-if="scope.row.ORMTB410CB10 == 1" type="primary"
                        class="public_icon_xiugai public_icon_width" size="small">启用线上结算
                      </el-button>
                    </el-dropdown-item>

                    <el-dropdown-item>
                      <el-button @click="updatefpfStatus(scope.row)" v-if="scope.row.ORMTB410CB18 == 1" type="error"
                        class="public_icon_xiugai public_icon_width" size="small"
                        style="color: red!important">关闭发票</el-button>
                      <el-button @click="updatefpfStatus(scope.row)" v-if="scope.row.ORMTB410CB18 == 0" type="primary"
                        class="public_icon_xiugai public_icon_width" size="small">启用发票
                      </el-button>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <el-button @click="updateycjsStatus(scope.row)" v-if="scope.row.ORMTB410CB24 == 1" type="error"
                        class="public_icon_xiugai public_icon_width" size="small"
                        style="color: red!important">关闭延迟结算运费</el-button>
                      <el-button @click="updateycjsStatus(scope.row)" v-if="scope.row.ORMTB410CB24 == 0" type="primary"
                        class="public_icon_xiugai public_icon_width" size="small">开启延迟结算运费
                      </el-button>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <el-button @click="updateslqxStatus(scope.row)" v-if="scope.row.ORMTB410CB21 == 1" type="error"
                        class="public_icon_xiugai public_icon_width" size="small"
                        style="color: red!important">屏蔽收料</el-button>
                      <el-button @click="updateslqxStatus(scope.row)" v-if="scope.row.ORMTB410CB21 == 0" type="primary"
                        class="public_icon_qiyong public_icon_width" size="small">开通收料
                      </el-button>
                    </el-dropdown-item>

                    <!-- <el-dropdown-item>
                      <el-button
                        type="primary"
                        style="color: red!important"
                        class="public_icon_xiugai public_icon_width"
                        size="small"
                        @click="yhSetuserClick(scope.row)"
                        >额外优惠设置
                      </el-button>
                    </el-dropdown-item> -->
                    <el-dropdown-item>
                      <el-button type="primary" style="color: red!important"
                        class="public_icon_xiugai public_icon_width" size="small" @click="ykblFun(scope.row)">油卡比例
                      </el-button>
                    </el-dropdown-item>

                    <!-- <el-dropdown-item>
                      <el-button
                        type="primary"
                        style="color: red!important"
                        class="public_icon_xiugai public_icon_width"
                        size="small"
                        @click="openWuliaoClick(scope.row)"
                        >返点
                      </el-button>
                    </el-dropdown-item> -->
                    <!-- <el-dropdown-item>
                      <el-button
                        type="success"
                        style=""
                        class="public_icon_xiugai public_icon_width"
                        size="small"
                        @click="openhanshuijiaClick(scope.row)"
                        >含税价设置
                      </el-button>
                    </el-dropdown-item> -->

                    <el-dropdown-item>
                      <el-button type="primary" style="color: red!important"
                        class="public_icon_xiugai public_icon_width" size="small"
                        @click="openWuliaoClickTj(scope.row)">返点统计
                      </el-button>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <el-button type="primary" style="color: red!important"
                        class="public_icon_xiugai public_icon_width" size="small"
                        @click="openShouQuanChangJia(scope.row)">授权厂家
                      </el-button>
                    </el-dropdown-item>
                    <el-dropdown-item v-if="uobj.pertb005.pertb005id == '20210914151855244350'">
                      <el-button type="primary" style="color: red!important"
                        class="public_icon_xiugai public_icon_width" size="small" @click="openCredit(scope.row)">授信
                      </el-button>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- </template> -->
        <!-- </RecycleScroller> -->
        <div class="customerManagementPC-page">
          <span style="font-size: 14px;color:#606266;" v-if="flag == '1'">共{{ count }}条</span>
          <el-pagination v-if="!flag" @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40, 100, 200]"
            layout="total, sizes,prev, pager, next" :page-size="pagesize" :total="count"></el-pagination>
        </div>
      </div>

      <div class="public-dialog">
        <el-dialog :title="useryhmsg.ORMTB410CA00 + ' 额外优惠设置'" :visible.sync="yhInsertShow" width="60%"
          @close="cusInsertClose" :closeOnClickModal="false">
          <el-table class="public_tableColumn" ref="multipleTable" :data="tableDatayh" tooltip-effect="dark"
            :row-key="row => row.SETTB414ID" :header-cell-style="{
              color: 'rgba(51,51,51,1)',
              background: 'rgba(184,227,255,1)',
              'font-weight': 'bold',
            }" :select-on-indeterminate="allChek" height="700" style="width: 100%"
            @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column label="厂家">
              <template slot-scope="scope">{{
                scope.row.SETTB414CA02
              }}</template>
            </el-table-column>
            <el-table-column prop="SETTB414CA03" label="单价扣减(元)">
              <template slot-scope="scope">
                <el-input v-model="scope.row.SETTB414CA03" placeholder="请输入内容"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="SETTB414CA04" label="整车折扣(%)">
              <template slot-scope="scope">
                <el-input v-model="scope.row.SETTB414CA04" placeholder="请输入内容"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="SETTB414CA05" label="整车优惠(元)">
              <template slot-scope="scope">
                <el-input v-model="scope.row.SETTB414CA05" placeholder="请输入内容"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="SETTB414CA07" width="260" label="是否享受统一单个物料优惠">
              <template slot-scope="scope">
                <el-select v-model="scope.row.SETTB414CA07" @change="dgwlyhFun" placeholder="请选择">
                  <el-option v-for="item in dgwlyhOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <!-- <el-input v-model="scope.row.SETTB414CA05" placeholder="请输入内容"></el-input> -->
              </template>
            </el-table-column>
            <el-table-column prop="SETTB414CA07" label="物料信息">
              <template slot-scope="scope">
                <!-- v-shiroHiden="solelist" id="修改" -->
                <el-button v-if="scope.row.SETTB414CA07 == '1'" type="primary"
                  class="public_icon_xiugai public_icon_width" size="small" @click="slmsgClick(scope.row)">物料信息
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="systemCorporateAccount-dialog-btn" style="margin-top: 20px">
            <!-- <el-button @click="toggleSelection([tableDatayh[1], tableDatayh[2]])">切换第二、第三行的选中状态</el-button> -->
            <!-- <el-button @click="selectData()">回显选中的数据</el-button> -->
            <!-- <el-button @click="toggleSelection()">取消选择</el-button> -->
            <el-button type="primary" @click="khyhserve()">提交</el-button>
            <el-button type="warning" @click="khyhqx()">取消</el-button>
          </div>
        </el-dialog>
      </div>

      <div class="public-dialog">
        <el-dialog title="油卡比例设置" :visible.sync="ykblInsertShow" width="60%" @close="cusInsertClose"
          :closeOnClickModal="false">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="auto" class="demo-ruleForm">
            <el-row :gutter="24">
              <el-col :span="10">
                <el-form-item label="客户名称" prop="khmc">
                  <el-input type="text" disabled placeholder="请输入内容" v-model="ruleForm.ORMTB410CA00">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="客户比例" prop="ORMTB410CB17">
                  <el-input type="number" placeholder="请输入内容" v-model="ruleForm.ORMTB410CB17">
                    <template slot="append">%</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item>
              <!-- submitForm -->
              <!-- preservationAdd -->
              <el-button type="primary" @click="preservationAdd('ruleForm')">提交</el-button>
              <el-button @click="resetForm('ruleForm')">取消</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </div>

      <div class="public-dialog">
        <el-dialog title="物料信息" :visible.sync="materShow" width="65%" :closeOnClickModal="false">
          <div class="public-chech systemCorporateAccount-dialog">
            <div class="public-chech-details">
              <div class="public-chech-details-tile">
                <div class="public-chech-details-tile-pre">物料类型：</div>
                <div class="public-chech-details-tile-pre-sel systemCorporateAccount-wuliao-input">
                  <el-select v-model="categoryMaterial">
                    <el-option v-for="item in materialTypeList" :key="item.SETTB206CA00" :label="item.SETTB206CA01"
                      :value="item.SETTB206CA00">
                    </el-option>
                  </el-select>
                </div>
                <div class="public-chech-details-tile-q">物料名称：</div>
                <div class="public-chech-details-tile-q-sel systemCorporateAccount-wuliao-input">
                  <input type="text" v-model="nameMaterial" placeholder="请输入" />
                  <el-button type="primary" style="margin-left: 20px;" @click="MaterialQuery">查询
                  </el-button>
                </div>
              </div>
              <div class="pulbic_oparetionBlock pulbic_table_container">
                <el-table :data="materList" style="width: 100%" stripe max-height="90%" class="public_tableColumn"
                  :header-cell-style="{
                    color: 'rgba(51,51,51,1)',
                    'font-weight': 'bold',
                  }">
                  <el-table-column align="center" prop="SETTB99CA00" label="企业名称"></el-table-column>
                  <el-table-column align="center" prop="SETTB109CA00" label="物料名称"></el-table-column>
                  <el-table-column align="center" prop="SETTB206CA01" label="物料类型"></el-table-column>
                  <el-table-column align="center" prop="SETTB109CA01_ys" label="零售价格"></el-table-column>
                  <el-table-column align="center" prop="SETTB109CA01" label="优惠价格"></el-table-column>
                  <!-- <el-table-column align="center" prop="SETTB109CA02" label="状态"></el-table-column> -->
                  <!-- <el-table-column align="center" prop="SETTB109CA05" label="计量单位"></el-table-column> -->
                  <!-- <el-table-column align="center" prop="SETTB109CB06" label="高度">
										<template slot-scope="scope">
											<span v-if="scope.row.SETTB109CB06">{{scope.row.SETTB109CB06}}</span>
											<span v-else>暂无数据</span>
										</template>

									</el-table-column>
									 -->
                  <el-table-column align="center" label="操作" width="260">
                    <template slot-scope="scope">
                      <el-button class="public_icon_xiugai public_icon_width" type="info" size="small"
                        @click="DiscountModify(scope.row)" id="优惠调控">
                        优惠调控
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="pulbic_pagesize">
                  <el-pagination @size-change="handleSizeChangeMaterial" @current-change="handleCurrentChangeMaterial"
                    :current-page.sync="currentPageMaterial" :page-sizes="[10, 20, 30, 40]" :page-size="limitMaterial"
                    layout="total,sizes, prev, pager, next" :total="pagingPageMaterial"></el-pagination>
                </div>
              </div>
            </div>
            <!-- <div class="public-dialog-btn">
							<el-button type="primary" @click="">保存</el-button>
							<el-button type="warning" @click="materShow=false">取消</el-button>
						</div> -->
          </div>
        </el-dialog>
      </div>

      <div class="public-dialog">
        <el-dialog :title="useryhmsg.ORMTB410CA00 + ' 优惠调控'" :visible.sync="discountShow" width="25%"
          :closeOnClickModal="false">
          <div class="systemCorporateAccount-dialog">
            <div class="systemCorporateAccount-dialog-li">
              <div class="SCADL-text">企业名称<span>*</span></div>
              <div class="SCADL-input">
                <input :disabled="disabled" type="text" v-model="enterNameMaterialModify" placeholder="请输入" readonly />
              </div>
            </div>
            <div class="systemCorporateAccount-dialog-li">
              <div class="SCADL-text">物料名称<span>*</span></div>
              <div class="SCADL-input">
                <input :disabled="disabled" type="text" v-model="nameMaterialModify" placeholder="请输入" />
              </div>
            </div>
            <div class="systemCorporateAccount-dialog-li">
              <div class="SCADL-text">浮动类型<span>*</span></div>
              <div class="SCADL-input">
                <el-radio v-model="floatingType" size="medium" label="1">上浮</el-radio>
                <el-radio v-model="floatingType" size="medium" label="2">下调</el-radio>
              </div>
            </div>
            <div class="systemCorporateAccount-dialog-li">
              <div class="SCADL-text">浮动金额<span>*</span></div>
              <div class="SCADL-input levelmang-table-KJ public-chech-details">
                <el-input-number class="num" style="text-align: center; font-size: 18px !important;" :precision="2"
                  :step="1" :min="0" :max="100" v-model="floatingAmount">
                </el-input-number>元
              </div>
            </div>
            <div class="systemCorporateAccount-dialog-btn">
              <el-button type="primary" @click="preservationDiscountModify">保存</el-button>
              <el-button type="warning" @click="discountShow = false">取消</el-button>
            </div>
          </div>
        </el-dialog>
      </div>

      <div class="public-dialog">
        <el-dialog title="新增客户" :visible.sync="cusInsertShow" width="30%" @close="cusInsertClose"
          :closeOnClickModal="false">
          <div class="customerManagementPC-add-customer">
            <div class="customerManagementPC-add-customer-li">
              <div class="customerManagementPC-add-customer-li-name">
                客户名称:
              </div>
              <div class="customerManagementPC-add-customer-li-ipt">
                <input type="text" v-model="cusInsertObj.ORMTB410CA00" maxlength="100" />
              </div>
              <div class="customerManagementPC-add-customer-li-type">
                *必填*
              </div>
            </div>
            <div class="customerManagementPC-add-customer-li">
              <div class="customerManagementPC-add-customer-li-name">简称:</div>
              <div class="customerManagementPC-add-customer-li-ipt">
                <input type="text" v-model="cusInsertObj.ORMTB410CA01" maxlength="20" />
              </div>
              <div class="customerManagementPC-add-customer-li-type"></div>
            </div>
            <div class="customerManagementPC-add-customer-li">
              <div class="customerManagementPC-add-customer-li-name">
                联系电话:
              </div>
              <div class="customerManagementPC-add-customer-li-ipt">
                <input type="text" v-model="cusInsertObj.ORMTB410CA02" maxlength="11" />
              </div>
              <div class="customerManagementPC-add-customer-li-type">
                *必填*
              </div>
            </div>
            <div class="customerManagementPC-add-customer-li" v-if="preferentialType == 1">
              <div class="customerManagementPC-add-customer-li-name">
                客户等级:
              </div>
              <div class="customerManagementPC-add-customer-li-ipt">
                <el-select v-model="cusInsertObj.ORMTB410CA06" placeholder="请选择">
                  <el-option v-for="item in customerManagementList" :key="item.SETTB206CA00" :label="item.SETTB206CA01"
                    :value="item.SETTB206CA00">
                  </el-option>
                </el-select>
              </div>
              <div class="customerManagementPC-add-customer-li-type">
                *必填*
              </div>
            </div>
            <div class="customerManagementPC-add-customer-btn">
              <el-button type="primary" @click="cusInsertServe">保存</el-button>
              <el-button type="info" @click="cusInsertShow = false">取消</el-button>
            </div>
          </div>
        </el-dialog>
      </div>

      <div class="public-dialog">
        <el-dialog title="用户下单等级冻结金额设置" :visible.sync="freezeInsertShow" width="30%" @close="cusInsertClose"
          :closeOnClickModal="false">
          <ul class="levelmang-table">
            <li class="levelmang-table-head">
              <div class="levelmang-table-JB">
                级别
              </div>
              <div class="levelmang-table-KJ">
                冻结倍数
              </div>
            </li>
            <li class="levelmang-table-li" v-for="(item, index) in tableDataGradePre" :key="index">
              <div class="levelmang-table-li-tab">
                <div class="levelmang-table-li-tab-li">
                  <div class="levelmang-table-JB">
                    {{ item.ORMTB405CA02 }}
                  </div>
                  <div class="levelmang-table-KJ public-chech-details">
                    <el-input-number :precision="1" :step="1" :min="0" :max="100"
                      v-model="item.ORMTB405CA01"></el-input-number>倍
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <div class="customerManagementPC-add-customer-btn">
            <el-button type="primary" @click="cusDJSetInsertServe">保存</el-button>
            <el-button type="info" @click="freezeInsertShow = false">取消</el-button>
          </div>
        </el-dialog>
      </div>

      <div class="public-dialog">
        <el-dialog title="用户下单冻结金额设置" :visible.sync="cusUDJSetpdateShow" width="30%" @close="upCusClose"
          :closeOnClickModal="false">
          <div class="customerManagementPC-add-customer">
            <div class="customerManagementPC-add-customer-li">
              <div class="customerManagementPC-add-customer-li-name">
                客户名称:
              </div>
              <div class="customerManagementPC-add-customer-li-ipt">
                <input type="text" disabled v-model="cusDJSetObj.ORMTB410CA00" maxlength="100" />
              </div>
              <div class="customerManagementPC-add-customer-li-type">
                *必填*
              </div>
            </div>
            <div class="customerManagementPC-add-customer-li">
              <div class="customerManagementPC-add-customer-li-name">
                联系电话:
              </div>
              <div class="customerManagementPC-add-customer-li-ipt">
                <input type="text" disabled v-model="cusDJSetObj.ORMTB410CA02" maxlength="11" />
              </div>
              <div class="customerManagementPC-add-customer-li-type">
                *必填*
              </div>
            </div>
            <div class="customerManagementPC-add-customer-li">
              <div class="customerManagementPC-add-customer-li-name">
                客户等级:
              </div>
              <div class="customerManagementPC-add-customer-li-ipt">
                <input type="text" disabled v-model="cusDJSetObj.ORMTB410CA06Name" maxlength="100" />
              </div>
              <div class="customerManagementPC-add-customer-li-type">
                *必填*
              </div>
            </div>
            <div class="customerManagementPC-add-customer-li">
              <div class="customerManagementPC-add-customer-li-name">
                保底冻结: (<span style="color:#409EFF;cursor: pointer;" @click="openAmount">修改记录</span>)
              </div>
              <div class="customerManagementPC-add-customer-li-ipt">
                <el-input-number :controls="false" v-model="cusDJSetObj.ORMTB410CB41"></el-input-number>
                <!-- <input type="number" v-model="cusDJSetObj.DJBSNum" maxlength="100" /> -->
              </div>
              <div class="customerManagementPC-add-customer-li-type">
                元*必填*
              </div>
            </div>
            <div class="customerManagementPC-add-customer-li">
              <div class="customerManagementPC-add-customer-li-name">
                冻结倍数: (<span style="color:#409EFF;cursor: pointer;" @click="openMultiple">修改记录</span>)
              </div>
              <div class="customerManagementPC-add-customer-li-ipt">
                <el-input-number :controls="false" :precision="1" :step="1" :min="0" :max="100"
                  v-model="cusDJSetObj.ORMTB410CB07"></el-input-number>
                <!-- <input type="number" v-model="cusDJSetObj.DJBSNum" maxlength="100" /> -->
              </div>
              <div class="customerManagementPC-add-customer-li-type">
                倍*必填*
              </div>
            </div>
            <div class="customerManagementPC-add-customer-btn">
              <el-button type="primary" @click="cusDJSetdateServe">保存</el-button>
              <el-button type="info" @click="cusUDJSetpdateShow = false">取消</el-button>
            </div>
          </div>
        </el-dialog>
      </div>

      <div class="public-dialog">
        <el-dialog title="编辑客户" :visible.sync="cusUpdateShow" width="30%" @close="upCusClose"
          :closeOnClickModal="false">
          <div class="customerManagementPC-add-customer">
            <div class="customerManagementPC-add-customer-li">
              <div class="customerManagementPC-add-customer-li-name">
                客户名称:
              </div>
              <div class="customerManagementPC-add-customer-li-ipt">
                <input type="text" v-model="cusUpdateObj.ORMTB410CA00" maxlength="100" />
              </div>
              <div class="customerManagementPC-add-customer-li-type">
                *必填*
              </div>
            </div>
            <div class="customerManagementPC-add-customer-li">
              <div class="customerManagementPC-add-customer-li-name">简称:</div>
              <div class="customerManagementPC-add-customer-li-ipt">
                <input type="text" v-model="cusUpdateObj.ORMTB410CA01" maxlength="20" />
              </div>
              <div class="customerManagementPC-add-customer-li-type"></div>
            </div>
            <div class="customerManagementPC-add-customer-li">
              <div class="customerManagementPC-add-customer-li-name">
                联系电话:
              </div>
              <div class="customerManagementPC-add-customer-li-ipt">
                <input type="text" v-model="cusUpdateObj.ORMTB410CA02" maxlength="11" />
              </div>
              <div class="customerManagementPC-add-customer-li-type">
                *必填*
              </div>
            </div>
            <div class="customerManagementPC-add-customer-li" v-if="preferentialType == 1">
              <div class="customerManagementPC-add-customer-li-name">
                客户等级:
              </div>
              <div class="customerManagementPC-add-customer-li-ipt">
                <el-select v-model="cusUpdateObj.ORMTB410CA06" placeholder="请选择">
                  <el-option v-for="item in customerManagementList" :key="item.SETTB206CA00" :label="item.SETTB206CA01"
                    :value="item.SETTB206CA00">
                  </el-option>
                </el-select>
              </div>
              <div class="customerManagementPC-add-customer-li-type">
                *必填*
              </div>
            </div>
            <div class="customerManagementPC-add-customer-btn">
              <el-button type="primary" @click="cusUpdateServe">保存</el-button>
              <el-button type="info" @click="cusUpdateShow = false">取消</el-button>
            </div>
          </div>
        </el-dialog>
      </div>

      <div class="public-dialog">
        <el-dialog title="充值类型管理" :visible.sync="saleWaterDetails" width="60%" @close="saleWaterDetailsclose"
          :closeOnClickModal="false">
          <div class="salesWatersStatisticsPC-saleWaterDetails">
            <div class="salesWatersStatisticsPC-saleWaterDetails-btn public_operatBtn" style="margin-left:0;">
              <button class="public_saleWater_xinzeng pulic_cursor" @click="rechargeTypeAdd">
                <i class="iconfont icon-tianjia1"></i>新增
              </button>
            </div>
            <div class="salesWatersStatisticsPC-saleWaterDetails-table pulbic_table_container">
              <el-table :data="tableDataDetails" style="width: 100%" stripe class="public_tableColumn"
                :header-cell-style="{
                  'font-family': 'Microsoft YaHei',
                  'font-weight': 'bold',
                  color: 'rgba(51,51,51,1)',
                }">
                <el-table-column prop="SETTB206CA01" label="充值类型名称">
                </el-table-column>
                <el-table-column prop="SETTB206CC01" label="创建人">
                </el-table-column>
                <el-table-column prop="SETTB206CC00" label="创建时间">
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <div class="CustomertopUpDig-content-table-btn">
                      <el-button class="public_icon_xiugai public_icon_width public_icon_margin" type="primary"
                        size="small" @click="rechargeTypeModify(scope.row)">修改
                      </el-button>
                      <el-button class="public_icon_jinyong public_icon_width" type="primary" size="small"
                        v-if="scope.row.SETTB206CA02 == 1" @click="disableCus(scope.row, 0)">禁用</el-button>
                      <el-button class="public_icon_qiyong public_icon_width" type="primary" size="small"
                        v-if="scope.row.SETTB206CA02 == 0" @click="disableCus(scope.row, 1)">启用</el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="billOperationRecord-page">
              <el-pagination @size-change="handleSizeChange1" @current-change="handleCurrentChange1"
                :current-page.sync="currentPage1" :page-sizes="[10, 20, 30, 40]" :page-size="detailsPageLimit"
                layout="total,sizes, prev, pager, next" :total="detailsCount">
              </el-pagination>
            </div>
          </div>
        </el-dialog>
      </div>
      <div class="public-dialog">
        <el-dialog title="客户等级管理" :visible.sync="customerManagement" width="60%" :closeOnClickModal="false">
          <div class="salesWatersStatisticsPC-saleWaterDetails">
            <div class="salesWatersStatisticsPC-saleWaterDetails-btn public_operatBtn" style="margin-left:0;">
              <button class="public_saleWater_xinzeng pulic_cursor" @click="customerManagementAdd = true">
                <i class="iconfont icon-tianjia1"></i>新增
              </button>
            </div>
            <div class="salesWatersStatisticsPC-saleWaterDetails-table pulbic_table_container">
              <el-table :data="customerManagementList" style="width: 100%" stripe class="public_tableColumn"
                :header-cell-style="{
                  'font-family': 'Microsoft YaHei',
                  'font-weight': 'bold',
                  color: 'rgba(51,51,51,1)',
                }">
                <el-table-column prop="SETTB206CA01" label="等级名称">
                </el-table-column>
                <el-table-column prop="SETTB206CC01" label="创建人">
                </el-table-column>
                <el-table-column prop="SETTB206CC00" label="创建时间">
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <div class="CustomertopUpDig-content-table-btn">
                      <el-button class="public_icon_xiugai public_icon_width public_icon_margin" type="primary"
                        size="small" @click="cusUpdataClick(scope.row)">修改
                      </el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-dialog>
      </div>
      <div class="public-dialog">
        <el-dialog title="新增" :visible.sync="customerManagementAdd" width="30%" @close="customerManagementAddName = ''"
          :closeOnClickModal="false">
          <div class="CustomerfillingDig-tab">
            <div class="rechargeType-tab-li">
              <div class="rechargeType-tab-li-text">等级名称：</div>
              <div class="rechargeType-tab-li-ipt">
                <input v-model="customerManagementAddName" type="text" maxlength="40" />
              </div>
              <div class="rechargeType-tab-li-b">*必填*</div>
            </div>
            <div class="CustomerfillingDig-tab-btn rechargeType-tab-btn">
              <el-button type="primary" @click="customerManagementAddServe">保存</el-button>
              <el-button type="warning" @click="customerManagementAdd = false">取消</el-button>
            </div>
          </div>
        </el-dialog>
      </div>
      <!-- 客户等级修改 -->
      <div class="public-dialog">
        <el-dialog title="修改" :visible.sync="customerManagementUpdate" width="30%" @close="customerManagemenUPObj = ''"
          :closeOnClickModal="false">
          <div class="CustomerfillingDig-tab">
            <div class="rechargeType-tab-li">
              <div class="rechargeType-tab-li-text">等级名称：</div>
              <div class="rechargeType-tab-li-ipt">
                <input v-model="customerManagemenUPObj.SETTB206CA01" type="text" />
              </div>
              <div class="rechargeType-tab-li-b">*必填*</div>
            </div>
            <div class="CustomerfillingDig-tab-btn rechargeType-tab-btn">
              <el-button type="primary" @click="customerManagementUpdateServe">保存</el-button>
              <el-button type="warning" @click="customerManagementUpdate = false">取消</el-button>
            </div>
          </div>
        </el-dialog>
      </div>
      <!-- 充值类型新增 rechargeTypeModifyDig-->
      <div class="public-dialog">
        <el-dialog title="新增" :visible.sync="rechargeTypeDig" width="30%" @close="rechargeTypeName = ''"
          :closeOnClickModal="false">
          <div class="CustomerfillingDig-tab">
            <div class="rechargeType-tab-li">
              <div class="rechargeType-tab-li-text">充值类型名称：</div>
              <div class="rechargeType-tab-li-ipt">
                <input v-model="rechargeTypeName" type="text" maxlength="40" />
              </div>
              <div class="rechargeType-tab-li-b">*必填*</div>
            </div>
            <div class="CustomerfillingDig-tab-btn rechargeType-tab-btn">
              <el-button type="primary" @click="rechaTypePreser">保存</el-button>
              <el-button type="warning" @click="rechargeTypeDig = false">取消</el-button>
            </div>
          </div>
        </el-dialog>
      </div>
      <!-- 充值类型修改 -->
      <div class="public-dialog">
        <el-dialog title="修改" :visible.sync="rechargeTypeModifyDig" width="30%" @close="rechargeTypeModifyClose"
          :closeOnClickModal="false">
          <div class="CustomerfillingDig-tab">
            <div class="rechargeType-tab-li">
              <div class="rechargeType-tab-li-text">充值类型名称：</div>
              <div class="rechargeType-tab-li-ipt">
                <input v-model="rechargeTypeUpOBJ.SETTB206CA01" type="text" />
              </div>
              <div class="rechargeType-tab-li-b">*必填*</div>
            </div>
            <div class="CustomerfillingDig-tab-btn rechargeType-tab-btn">
              <el-button type="primary" @click="rechaTypePreserModify">保存</el-button>
              <el-button type="warning" @click="rechargeTypeModifyDig = false">取消</el-button>
            </div>
          </div>
        </el-dialog>
      </div>
      <!--  -->
      <div class="public-dialog">
        <el-dialog title="充值" :visible.sync="CustomerfillingDig" width="40%"
          @close="; (CZmoney = ''), (amountCapitalText = ''), (CZremark = '')" :closeOnClickModal="false">
          <div style="max-height: 500px;overflow-y: auto;">
            <div class="CustomerfillingDig-tab">
              <div class="CustomerfillingDig-tab-li">
                <div class="CustomerfillingDig-tab-li-text">客户名称：</div>
                <div class="CustomerfillingDig-tab-li-ipt">
                  {{ cusUpdateObj.ORMTB410CA00 }}
                </div>
                <div class="CustomerfillingDig-tab-li-b"></div>
              </div>
              <div class="CustomerfillingDig-tab-li">
                <div class="CustomerfillingDig-tab-li-text">充值类型：</div>
                <div class="CustomerfillingDig-tab-li-ipt">
                  <el-select v-model="RechargetypeValue" placeholder="请选择">
                    <el-option v-for="item in RechargetypeOptions" :key="item.SETTB206CA01" :label="item.SETTB206CA01"
                      :value="item.SETTB206CA01">
                    </el-option>
                  </el-select>
                </div>
                <div class="CustomerfillingDig-tab-li-b">*必选*</div>
              </div>
              <div class="CustomerfillingDig-tab-li">
                <div class="CustomerfillingDig-tab-li-text">变动方式：</div>
                <div class="CustomerfillingDig-tab-li-ipt">
                  <el-select v-model="wayTypeValue" disabled placeholder="请选择">
                    <el-option v-for="item in wayTypeOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div class="CustomerfillingDig-tab-li-b">*必选*</div>
              </div>
              <div class="CustomerfillingDig-tab-li">
                <div class="CustomerfillingDig-tab-li-text">余额：</div>
                <div class="CustomerfillingDig-tab-li-ipt">
                  {{ cusUpdateObj.ORMTB410CA03 }}
                </div>
                <div class="CustomerfillingDig-tab-li-b">*必填*</div>
              </div>
              <div class="CustomerfillingDig-tab-li">
                <div class="CustomerfillingDig-tab-li-text">充值金额：</div>
                <div class="CustomerfillingDig-tab-li-ipt">
                  <!-- ref="topMoney" -->
                  <el-input type="text" v-model="CZmoney" :maxlength="Czmaxlength" @input="topMoneyInput"
                    @change="topMoneyChange"></el-input>
                </div>
                <div class="CustomerfillingDig-tab-li-b">*必填*</div>
              </div>
              <div class="CustomerfillingDig-tab-li">
                <div class="CustomerfillingDig-tab-li-text">备注：</div>
                <div class="CustomerfillingDig-tab-li-ipt">
                  <input type="text" v-model="CZremark" maxlength="100" />
                </div>
                <div class="CustomerfillingDig-tab-li-b">*必填*</div>
              </div>
              <div class="CustomerfillingDig-priceNumtext">
                金额大写：<span>{{ amountCapitalText }}</span>
              </div>
              <div class="CustomerfillingDig-tab-btn">
                <!-- @click="CZserve()" -->
                <el-button type="primary" @click="innerVisibleClick()">确认充值</el-button>
                <el-button type="warning" @click="CustomerfillingDig = false">取消</el-button>
              </div>
            </div>
          </div>
          <el-dialog width="40%" title="充值信息" :visible.sync="innerVisible" append-to-body>
            <div style="max-height: 500px;overflow-y: auto;">
              <div class="CustomerfillingDig-tab">
                <div class="CustomerfillingDig-tab-li">
                  <div class="CustomerfillingDig-tab-li-text">客户名称：</div>
                  <div class="CustomerfillingDig-tab-li-ipt">
                    {{ cusUpdateObj.ORMTB410CA00 }}
                  </div>
                  <div class="CustomerfillingDig-tab-li-b"></div>
                </div>
                <div class="CustomerfillingDig-tab-li">
                  <div class="CustomerfillingDig-tab-li-text">充值类型：</div>
                  <div class="CustomerfillingDig-tab-li-ipt">
                    {{ RechargetypeValue }}
                  </div>
                  <div class="CustomerfillingDig-tab-li-b"></div>
                </div>
                <div class="CustomerfillingDig-tab-li">
                  <div class="CustomerfillingDig-tab-li-text">变动方式：</div>
                  <div class="CustomerfillingDig-tab-li-ipt">财务</div>
                  <div class="CustomerfillingDig-tab-li-b"></div>
                </div>
                <div class="CustomerfillingDig-tab-li">
                  <div class="CustomerfillingDig-tab-li-text">余额：</div>
                  <div class="CustomerfillingDig-tab-li-ipt">
                    {{ cusUpdateObj.ORMTB410CA03 }}
                  </div>
                  <div class="CustomerfillingDig-tab-li-b"></div>
                </div>
                <div class="CustomerfillingDig-tab-li">
                  <div class="CustomerfillingDig-tab-li-text">充值金额：</div>
                  <div class="CustomerfillingDig-tab-li-ipt">
                    {{ amountCapitalText }}
                  </div>
                  <div class="CustomerfillingDig-tab-li-b"></div>
                </div>
                <div class="CustomerfillingDig-tab-li">
                  <div class="CustomerfillingDig-tab-li-text">备注：</div>
                  <div class="CustomerfillingDig-tab-li-ipt">
                    {{ CZremark }}
                  </div>
                  <div class="CustomerfillingDig-tab-li-b"></div>
                </div>

                <!-- <el-row :gutter="20">
									<el-col :span="6">
										<div class="grid-content bg-purple"></div>
									</el-col>
									<el-col :span="6">
										<div class="grid-content bg-purple"></div>
									</el-col>
									<el-col :span="6">
										<div class="grid-content bg-purple"></div>
									</el-col>
									<el-col :span="6">
										<div class="grid-content bg-purple"></div>
									</el-col>
								</el-row> -->

                <div class="CustomerfillingDig-tab-btn">
                  <!-- @click="CZserve()" -->
                  <el-button type="primary" @click="CZserve()">充值提交</el-button>
                  <el-button type="warning" @click="innerVisible = false">取消</el-button>
                </div>
              </div>
            </div>
          </el-dialog>
        </el-dialog>
      </div>
      <div class="public-dialog">
        <!-- wayTypeValue='' -->
        <el-dialog title="红冲" :visible.sync="HCshow" width="40%"
          @close="; (HCObj = ''), (HCmoney = ''), (HCamountCapitalText = '')" :closeOnClickModal="false">
          <div style="max-height: 500px;overflow-y: auto;">
            <div class="CustomerfillingDig-tab">
              <div class="CustomerfillingDig-tab-li">
                <div class="CustomerfillingDig-tab-li-text">客户名称：</div>
                <div class="CustomerfillingDig-tab-li-ipt">
                  {{ cusUpdateObj.ORMTB410CA00 }}
                </div>
                <div class="CustomerfillingDig-tab-li-b"></div>
              </div>
              <div class="CustomerfillingDig-tab-li">
                <div class="CustomerfillingDig-tab-li-text">钱包余额：</div>
                <div class="CustomerfillingDig-tab-li-ipt">
                  {{ cusUpdateObj.ORMTB410CA03 }}
                </div>
                <div class="CustomerfillingDig-tab-li-b"></div>
              </div>
              <div class="CustomerfillingDig-tab-li">
                <div class="CustomerfillingDig-tab-li-text">运费余额：</div>
                <div class="CustomerfillingDig-tab-li-ipt">
                  {{ cusUpdateObj.ORMTB410CB26 }}
                </div>
                <div class="CustomerfillingDig-tab-li-b"></div>
              </div>
              <div class="CustomerfillingDig-tab-li">
                <div class="CustomerfillingDig-tab-li-text">红冲金额：</div>
                <div class="CustomerfillingDig-tab-li-ipt">
                  <!-- ref="HCmoney" -->
                  <el-input type="text" v-model="HCmoney" maxlength="12" @input="HCMoneyInput"
                    @change="HCMoneyChange"></el-input>
                </div>
                <div class="CustomerfillingDig-tab-li-b">*必填*</div>
              </div>


              <div class="CustomerfillingDig-tab-li">
                <div class="CustomerfillingDig-tab-li-text">红冲账户类型：</div>
                <div class="CustomerfillingDig-tab-li-ipt">
                  <el-select v-model="hczhlxValue" placeholder="请选择">
                    <el-option v-for="item in hczhlxOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div class="CustomerfillingDig-tab-li-b">*必选*</div>
              </div>

              <div class="CustomerfillingDig-tab-li">
                <div class="CustomerfillingDig-tab-li-text">备注：</div>
                <div class="CustomerfillingDig-tab-li-ipt">
                  <input type="text" v-model="HCremark" maxlength="100" />
                </div>
                <div class="CustomerfillingDig-tab-li-b">*必填*</div>
              </div>
              <div class="CustomerfillingDig-priceNumtext">
                金额大写：<span>{{ HCamountCapitalText }}</span>
              </div>
              <div class="CustomerfillingDig-tab-btn">
                <el-button type="primary" @click="HCserve()">确认</el-button>
                <el-button type="warning" @click="HCshow = false">取消</el-button>
              </div>
            </div>
          </div>
        </el-dialog>
      </div>
      <div class="public-dialog">
        <el-dialog title="充值优惠记录" :visible.sync="preferentialRecord" @close="
          upCusClose,
          (CZRecordsPage = 1),
          (CZRecordsPageLimit = 10),
          (CZRecordsCount = 0),
          (page = 1)
          " width="90%" :closeOnClickModal="false">
          <div style="max-height: 500px;overflow-y: auto;">
            <div class="salesWatersStatisticsPC-saleWaterDetails-table pulbic_table_container">
              <el-table :data="CZRecordsDetails" style="width: 100%" stripe class="public_tableColumn"
                :header-cell-style="{
                  'font-family': 'Microsoft YaHei',
                  'font-weight': 'bold',
                  color: 'rgba(51,51,51,1)',
                }">
                <el-table-column prop="ORMTB410CA00" label="客户名称">
                </el-table-column>
                <el-table-column prop="ORMTB411CA03" label="充值时间">
                </el-table-column>
                <el-table-column prop="ORMTB411CA04" label="充值类型">
                </el-table-column>
                <el-table-column prop="ORMTB411CA00" label="充值金额">
                </el-table-column>
                <el-table-column prop="ORMTB411CA01" label="剩余金额">
                </el-table-column>
                <!-- <el-table-column prop="" label="在线类型">
								</el-table-column> -->
                <!-- <el-table-column prop="" label="优惠类型">
								</el-table-column> -->
                <!-- <el-table-column prop="" label="价格区间">
								</el-table-column> -->
                <el-table-column prop="ORMTB411CA02" label="充值人">
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button class="public_icon_chongzhi public_icon_width public_icon_margin" type="primary"
                      size="small" @click="HCclick(scope.row), (HCshow = true)" id="优惠明细">红冲
                    </el-button>
                    <el-button class="public_icon_chongzhi public_icon_width public_icon_margin" type="primary"
                      size="small" @click="offerDetailsClick(scope.row)" id="优惠明细">
                      优惠明细</el-button>
                    <el-button class="public_icon_chongzhi public_icon_width public_icon_margin" type="primary"
                      size="small" @click="
                        deductionRecordClick(scope.row),
                        (deductionRecord = true)
                        " id="变动记录">变动记录
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="billOperationRecord-page">
              <el-pagination @size-change="CZRecordsSizeChange" @current-change="CZRecordsCurrentChange"
                :current-page.sync="CZRecordsPage" :page-sizes="[10, 20, 30, 40]" :page-size="CZRecordsPageLimit"
                layout="total,sizes, prev, pager, next" :total="CZRecordsCount">
              </el-pagination>
            </div>
          </div>
        </el-dialog>
      </div>
      <div class="public-dialog">
        <el-dialog title="优惠明细" :visible.sync="offerDetails" width="30%" :closeOnClickModal="false">
          <el-table :data="offerDetailsTab" style="width: 100%" stripe class="public_tableColumn" :header-cell-style="{
            'font-family': 'Microsoft YaHei',
            'font-weight': 'bold',
            color: 'rgba(51,51,51,1)',
          }">
            <el-table-column prop="SETTB99CA00" label="关联厂区">
            </el-table-column>
            <el-table-column prop="ORMTB412CA01" label="优惠方式">
            </el-table-column>
            <el-table-column prop="ORMTB412CA00" label="优惠金额">
            </el-table-column>
          </el-table>
        </el-dialog>
      </div>
      <div class="public-dialog">
        <el-dialog title="变动记录" :visible.sync="deductionRecord" width="70%" @close="
            ; (ORMTB411ID = ''),
          (deductionRecordPage = 1),
          (deductionRecordLimit = 10),
          (deductionRecordCount = 0)
          " :closeOnClickModal="false">
          <el-table :data="deductionRecordtable" style="width: 100%" stripe class="public_tableColumn"
            :header-cell-style="{
              'font-family': 'Microsoft YaHei',
              'font-weight': 'bold',
              color: 'rgba(51,51,51,1)',
            }">
            <el-table-column prop="ORMTB413CA01" label="扣费时间">
            </el-table-column>
            <el-table-column prop="ORMTB440CA00" label="派单号">
            </el-table-column>
            <!-- <el-table-column prop="" label="客户名称">
						</el-table-column> -->
            <!-- <el-table-column prop="" label="扣前金额">
						</el-table-column> -->
            <el-table-column prop="ORMTB413CA00" label="扣款金额">
            </el-table-column>
            <el-table-column prop="ORMTB413CA02" label="变动类型">
            </el-table-column>
            <!-- <el-table-column prop="" label="扣后金额">
						</el-table-column> -->
            <el-table-column prop="" label="操作">
              <template slot-scope="scope">
                <el-button v-if="scope.row.ORMTB413CA02 != '红冲'"
                  class="public_icon_chongzhi public_icon_width public_icon_margin" type="primary" size="small"
                  @click="DetailsWaterClick(scope.row)" id="详情">详情</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="billOperationRecord-page">
            <el-pagination @size-change="deductionRecordSizeChange" @current-change="deductionRecordCurrentChange"
              :current-page.sync="deductionRecordPage" :page-sizes="[10, 20, 30, 40]" :page-size="deductionRecordLimit"
              layout="total,sizes, prev, pager, next" :total="deductionRecordCount">
            </el-pagination>
          </div>
        </el-dialog>
      </div>
      <div class="public-dialog">
        <el-dialog title="详情" :visible.sync="DetailsWater" width="30%" :closeOnClickModal="false">
          <div class="DetailsWater-Dialog">
            <div class="DWD-li">
              <div class="DWD-li-title">流水号</div>
              <div class="DWD-li-text">
                {{ deductionRecordObj.ORMTB440CA00 || '' }}
              </div>
            </div>
            <div class="DWD-li">
              <div class="DWD-li-title">企业名称</div>
              <div class="DWD-li-text">
                {{ deductionRecordObj.ORMTB440CA05 || '' }}
              </div>
            </div>
            <div class="DWD-li">
              <div class="DWD-li-title">客户名称</div>
              <div class="DWD-li-text">
                {{ deductionRecordObj.ORMTB440CA03 || '' }}
              </div>
            </div>
            <div class="DWD-li">
              <div class="DWD-li-title">车牌号</div>
              <div class="DWD-li-text">
                {{ deductionRecordObj.ORMTB440CA01 || '' }}
              </div>
            </div>
            <div class="DWD-li">
              <div class="DWD-li-title">派单时间</div>
              <div class="DWD-li-text">
                {{ deductionRecordObj.ORMTB440CA19 || '' }}
              </div>
            </div>
            <div class="DWD-li">
              <div class="DWD-li-title">结算时间</div>
              <div class="DWD-li-text">
                {{ deductionRecordObj.ORMTB440CC00 || '' }}
              </div>
            </div>
            <div class="DWD-li">
              <div class="DWD-li-title">回执时间</div>
              <div class="DWD-li-text">
                {{ deductionRecordObj.ORMTB440CE00 || '' }}
              </div>
            </div>
            <div class="DWD-table">
              <div class="DWD-table-left-title">
                <div></div>
                <div>派单</div>
                <div>结算</div>
                <div>回执</div>
              </div>
              <div class="DWD-table-left-flex">
                <div>物料</div>
                <div>{{ deductionRecordObj.ORMTB440CA07 || '' }}</div>
                <div>{{ deductionRecordObj.ORMTB440CC02 || '' }}</div>
                <div></div>
              </div>
              <div class="DWD-table-left-flex">
                <div>重量</div>
                <div>{{ deductionRecordObj.ORMTB440CA10 || 0 }}</div>
                <div>{{ deductionRecordObj.ORMTB440CC04 || 0 }}</div>
                <div v-if="deductionRecordObj.ORMTB440CF01 == '5'">
                  {{ deductionRecordObj.ORMTB440CE09 || 0 }}
                </div>
                <div v-else></div>
              </div>
              <div class="DWD-table-left-flex">
                <div>物料金额</div>
                <div>{{ deductionRecordObj.ORMTB440CA11 || 0 }}</div>
                <div>{{ deductionRecordObj.ORMTB440CC06 || 0 }}</div>
                <div></div>
              </div>
              <div class="DWD-table-left-flex">
                <div>运费金额</div>
                <div>{{ deductionRecordObj.ORMTB440CA12 || 0 }}</div>
                <div>{{ deductionRecordObj.jsORMTB440CA12 || 0 }}</div>
                <div v-if="deductionRecordObj.ORMTB440CF01 == '5'">
                  {{ deductionRecordObj.ORMTB440CE10 || 0 }}
                </div>
                <div v-else></div>
              </div>
            </div>
          </div>
          <div class="DetailsWater-img">
            <div class="DetailsWater-img-text">回执记录</div>
            <el-image style="width: 80px; height: 80px" :src="DetailsWaterurl" :preview-src-list="DetailsWatersrcList">
            </el-image>
          </div>
        </el-dialog>
      </div>

      <!--      物料弹窗-->
      <div class="public-dialog">
        <el-dialog title="返点调控" :visible.sync="wuliaoShow" width="65%" :closeOnClickModal="false">
          <div class="customerManagementPC-btn public_operatBtn" style="margin-left: 0px;">
            <el-button class="public_saleWater_xinzeng" style="margin-left: 51px" type="primary" id="新增"
              @click="fandianAdd">
              <i class="iconfont icon-tianjia1"></i>新增
            </el-button>
          </div>
          <div class="public-chech systemCorporateAccount-dialog">
            <div class="public-chech-details">
              <div class="pulbic_oparetionBlock pulbic_table_container">
                <el-table :data="fdList" style="width: 100%" stripe max-height="90%" class="public_tableColumn"
                  :header-cell-style="{
                    color: 'rgba(51,51,51,1)',
                    'font-weight': 'bold',
                  }">
                  <el-table-column align="center" prop="SETTB420CA00" label="企业名称"></el-table-column>
                  <el-table-column align="center" prop="SETTB420CA02" label="物料名称"></el-table-column>
                  <el-table-column align="center" prop="SETTB420CA07" label="返点比率"></el-table-column>
                  <el-table-column align="center" prop="SETTB420CA09" label="开始时间"></el-table-column>
                  <el-table-column align="center" prop="SETTB420CA10" label="结束时间"></el-table-column>
                  <el-table-column align="center" label="操作" width="260">
                    <template slot-scope="scope">
                      <!--                      <el-button class="public_icon_xiugai public_icon_width" type="info"-->
                      <!--                                 size="small" @click="fandianModify(scope.row)" id="修改">-->
                      <!--                        修改-->
                      <!--                      </el-button>-->
                      <el-button class="public_icon_xiugai public_icon_width" type="info" size="small"
                        @click="deleteFd(scope.row)" id="删除">
                        删除
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="pulbic_pagesize">
                  <el-pagination @size-change="fdhandleSizeChangeMaterial"
                    @current-change="fdhandleCurrentChangeMaterial" :current-page.sync="currentPageMaterial"
                    :page-sizes="[10, 20, 30, 40]" :page-size="fdListlimitMaterial"
                    layout="total,sizes, prev, pager, next" :total="fdListpagingPageMaterial"></el-pagination>
                </div>
              </div>
            </div>
            <!-- <div class="public-dialog-btn">
              <el-button type="primary" @click="">保存</el-button>
              <el-button type="warning" @click="materShow=false">取消</el-button>
            </div> -->
          </div>
        </el-dialog>
      </div>

      <!--      含税价设置-->
      <div class="public-dialog">
        <el-dialog :title="objuserMsg.ORMTB410CA00 + '的含税价格设置'" :visible.sync="hanshuijiaShow" width="65%"
          :closeOnClickModal="false" @close="hsjszCloFun()">
          <div class="customerManagementPC-btn public_operatBtn" style="margin-left: 0px;">
            <!-- <el-button class="public_saleWater_xinzeng" style="margin-left: 51px" type="primary"
							v-shiroHiden="solelist" id="新增" @click="fandianAdd">
							<i class="iconfont icon-tianjia1"></i>新增
						</el-button> -->
            <div style="padding-bottom: 20px;">
              <el-row>
                <div style="padding-bottom: 20px;">
                  已开启含税价厂家:
                  <span v-if="ykhsjcjList.length == 0">暂无</span>
                </div>

                <el-col v-for="item in ykhsjcjList" :span="4">
                  <div class="grid-content bg-purple" style="padding: 10px 0;">
                    {{ item.ORMTB703CA03 }}
                  </div>
                </el-col>
              </el-row>
            </div>

            <label class="public_lbSty">厂家：</label>
            <el-select class="public_optionSty dropDown_Define" @change="fdPageMaterialList" v-model="fdObj.cjId"
              placeholder="请选择" filterable>
              <el-option v-for="item in cjList" :key="item.SETTB99ID" :label="item.SETTB99CA00" :value="item.SETTB99ID">
              </el-option>
            </el-select>
            <el-switch size="small" v-model="hanshuijiaKG" active-text="开启含税价" inactive-text="关闭含税价"
              @change="hanshuijiaKGFun">
            </el-switch>
          </div>
          <div class="public-chech systemCorporateAccount-dialog">
            <div class="public-chech-details">
              <div class="pulbic_oparetionBlock pulbic_table_container">
                <el-table :data="fdmaterList" style="width: 100%" stripe max-height="90%" class="public_tableColumn"
                  :header-cell-style="{
                    color: 'rgba(51,51,51,1)',
                    'font-weight': 'bold',
                  }">
                  <el-table-column align="center" prop="SETTB99CA00" label="企业名称"></el-table-column>
                  <el-table-column align="center" prop="SETTB109CA00" label="物料名称"></el-table-column>
                  <!-- <el-table-column align="center" prop="SETTB206CA01" label="物料类型"></el-table-column> -->
                  <el-table-column align="center" prop="SETTB109CA01_ys" label="零售价格"></el-table-column>
                  <el-table-column align="center" prop="SETTB109CA01" label="不含税价格"></el-table-column>
                  <el-table-column align="center" prop="SETTB109CA01_hs" label="含税价格"></el-table-column>
                  <!-- <el-table-column align="center" prop="SETTB420CA10"
										:label="labeText"></el-table-column> -->

                  <!-- <el-table-column align="center" label="操作" width="260">
										<template slot-scope="scope">

											<el-button class="public_icon_xiugai public_icon_width" type="info"
												size="small" @click="deleteFd(scope.row)" id="删除">
												删除
											</el-button>
										</template>
									</el-table-column> -->
                </el-table>
                <div class="pulbic_pagesize">
                  <el-pagination @size-change="hsjhandleSizeChangeMaterial"
                    @current-change="hsjhandleCurrentChangeMaterial" :current-page.sync="hsjListpageMaterial"
                    :page-sizes="[10, 20, 30, 40]" :page-size="hsjListlimitMaterial"
                    layout="total,sizes, prev, pager, next" :total="hsjListpagingPageMaterial"></el-pagination>
                </div>
                <div class="systemCorporateAccount-dialog-btn" style="margin-top: 20px">
                  <el-button type="primary" @click="hsjyhserve()">提交</el-button>
                  <el-button type="warning" @click="hsjszCloFun()">取消</el-button>
                </div>
              </div>
            </div>
            <!-- <div class="public-dialog-btn">
	                <el-button type="primary" @click="">保存</el-button>
	                <el-button type="warning" @click="materShow=false">取消</el-button>
	              </div> -->
          </div>
        </el-dialog>
      </div>

      <!--返点调控-->
      <div class="public-dialog">
        <el-dialog title="新增返点信息" :visible.sync="fandianShow" width="25%" :closeOnClickModal="false">
          <div class="systemCorporateAccount-dialog">
            <div class="systemCorporateAccount-dialog-li">
              <div class="SCADL-text">企业名称<span>*</span></div>
              <div class="SCADL-input">
                <!--                <input :disabled="disabled" type="text" v-model="fdObj.cjName"-->
                <!--                       placeholder="请输入" readonly>-->
                <el-select class="public_optionSty dropDown_Define" @change="fdPageMaterialList" v-model="fdObj.cjId"
                  placeholder="请选择" filterable>
                  <el-option v-for="item in cjList" :key="item.SETTB99ID" :label="item.SETTB99CA00"
                    :value="item.SETTB99ID">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="systemCorporateAccount-dialog-li">
              <div class="SCADL-text">物料名称</div>
              <div class="SCADL-input">
                <el-select class="public_optionSty dropDown_Define" @change="onSelecteLable" @clear="clearFunWl"
                  v-model="fdObj.wls" clearable multiple collapse-tags placeholder="请选择" filterable>
                  <el-option v-for="item in fdmaterList" :key="item.SETTB109ID" :label="item.SETTB109CA00"
                    :value="item.SETTB109ID">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="systemCorporateAccount-dialog-li">
              <div class="SCADL-text">返点比率<span>*</span></div>
              <div class="SCADL-input">
                <input type="text" v-model="fdObj.fdbl" placeholder="请输入" />
              </div>
            </div>
            <div class="systemCorporateAccount-dialog-li">
              <div class="SCADL-text">开始时间<span>*</span></div>
              <div class="SCADL-input">
                <el-date-picker v-model="fdObj.startTime" type="datetime" placeholder="选择日期时间">
                </el-date-picker>
              </div>
            </div>
            <div class="systemCorporateAccount-dialog-li">
              <div class="SCADL-text">结束时间<span>*</span></div>
              <div class="SCADL-input">
                <el-date-picker v-model="fdObj.endTime" type="datetime" placeholder="选择日期时间">
                </el-date-picker>
              </div>
            </div>
            <div class="systemCorporateAccount-dialog-btn">
              <el-button type="primary" @click="commitVerify">保存</el-button>
              <el-button type="warning" @click="fandianShow = false">取消</el-button>
            </div>
          </div>
        </el-dialog>
      </div>

      <!--      返点统计列表-->
      <div class="public-dialog">
        <el-dialog title="返点统计" :visible.sync="wuliaoShowTj" width="65%" :closeOnClickModal="false">
          <div class="public-chech systemCorporateAccount-dialog">
            <div class="public-chech-details">
              <!--                <div class="pulbic_oparetionBlock pulbic_table_container">-->
              <el-table :data="fdListTj" style="width: 100%" stripe max-height="90%" class="public_tableColumn"
                :header-cell-style="{
                  color: 'rgba(51,51,51,1)',
                  'font-weight': 'bold',
                }">
                <el-table-column align="center" prop="cjmc" label="厂家名称"></el-table-column>
                <el-table-column align="center" prop="khmc" label="客户名称"></el-table-column>
                <el-table-column align="center" prop="wlmc" label="物料名称"></el-table-column>
                <el-table-column align="center" prop="starttime" label="开始时间" width="160px"></el-table-column>
                <el-table-column align="center" prop="endtime" label="结束时间" width="160px"></el-table-column>
                <el-table-column align="center" prop="jsds" label="结算吨数"></el-table-column>
                <el-table-column align="center" prop="fdbl" label="返点比率"></el-table-column>
                <el-table-column align="center" prop="je" label="返点金额"></el-table-column>
              </el-table>
              <!--              </div>-->
            </div>
          </div>
        </el-dialog>
      </div>
      <!-- 设置授权厂家 -->
      <div class="public-dialog">
        <el-dialog title="授权厂家" :visible.sync="shouQuanChangJiaShow" width="65%" :closeOnClickModal="false">
          <div class="public-chech shouQuanChangJia-dialog">
            <div class="public-chech-details">
              <el-checkbox v-model="checkAllCj" :indeterminate="isIndeterminateCj"
                @change="handlecheckAllCjChange">全选</el-checkbox>
              <el-checkbox-group v-model="checkedCitiesName" @change="handlecheckedCitiesNameChange">
                <el-checkbox v-for="(city, i) in factoryList" :label="city.SETTB99CA00" :key="city.SETTB99ID">
                  {{ city.SETTB99CA00 }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
            <div class="cJ-btn">
              <el-button type="primary" @click="preservationModify">提交</el-button>
              <el-button @click="cancelModify">取消</el-button>
            </div>
          </div>
        </el-dialog>
      </div>
      <!-- 保底冻结修改记录 -->
      <div class="public-dialog">
        <el-dialog title="保底冻结修改记录" :visible.sync="amountRecord" width="60%" :closeOnClickModal="false">
          <div class="salesWatersStatisticsPC-saleWaterDetails">
            <div class="salesWatersStatisticsPC-saleWaterDetails-table pulbic_table_container">
              <el-table :data="amountRecordList" style="width: 100%" stripe class="public_tableColumn"
                :header-cell-style="{
                  'font-family': 'Microsoft YaHei',
                  'font-weight': 'bold',
                  color: 'rgba(51,51,51,1)',
                }">
                <el-table-column prop="ORMTB410CA00" label="客户">
                </el-table-column>
                <el-table-column prop="ORMTB410DJ03" label="上次保底冻结">
                </el-table-column>
                <el-table-column prop="ORMTB410DJ04" label="现在保底冻结">
                </el-table-column>
                <el-table-column prop="ORMTB410DJ05" label="修改时间">
                </el-table-column>
                <el-table-column prop="ORMTB410DJ06" label="修改人">
                </el-table-column>
              </el-table>
            </div>
            <div class="billOperationRecord-page">
              <el-pagination @size-change="handleSizeChangeAmount" @current-change="handleCurrentChangeAmount"
                :current-page.sync="currentPageAmount" :page-sizes="[10, 20, 30, 40]" :page-size="amountPageSize"
                layout="total,sizes, prev, pager, next" :total="amountTotal">
              </el-pagination>
            </div>
          </div>
        </el-dialog>
      </div>
      <!--  -->
      <div class="public-dialog">
        <el-dialog title="冻结倍数修改记录" :visible.sync="multipleRecord" width="60%" :closeOnClickModal="false">
          <div class="salesWatersStatisticsPC-saleWaterDetails">
            <div class="salesWatersStatisticsPC-saleWaterDetails-table pulbic_table_container">
              <el-table :data="multipleRecordList" style="width: 100%" stripe class="public_tableColumn"
                :header-cell-style="{
                  'font-family': 'Microsoft YaHei',
                  'font-weight': 'bold',
                  color: 'rgba(51,51,51,1)',
                }">
                <el-table-column prop="ORMTB410CA00" label="客户">
                </el-table-column>
                <el-table-column prop="ORMTB410DJ01" label="上次冻结倍数">
                </el-table-column>
                <el-table-column prop="ORMTB410DJ02" label="现在冻结倍数">
                </el-table-column>
                <el-table-column prop="ORMTB410DJ05" label="修改时间">
                </el-table-column>
                <el-table-column prop="ORMTB410DJ06" label="修改人">
                </el-table-column>
              </el-table>
            </div>
            <div class="billOperationRecord-page">
              <el-pagination @size-change="handleSizeChangeMultiple" @current-change="handleCurrentChangeMultiple"
                :current-page.sync="currentPageMultiple" :page-sizes="[10, 20, 30, 40]" :page-size="multiplePageSize"
                layout="total,sizes, prev, pager, next" :total="multipleTotal">
              </el-pagination>
            </div>
          </div>
        </el-dialog>
      </div>
      <!-- 客户账单日报记录 -->
      <div class="public-dialog">
        <el-dialog title="客户账单日报记录" :visible.sync="customerBillShow" width="80%" :closeOnClickModal="false">
          <div class="salesWatersStatisticsPC-saleWaterDetails">
            <div class="customerBillTable">
              <div class="public_criteriaRange customerManagementPC-select">
                <div class="public_oparetionBlock_Menu">
                  <label class="public_lbSty">客户名称：</label>
                  <el-select class="public_optionSty dropDown_Define" v-model="dayRecord.ORMTB410ID" @clear="clearFun"
                    filterable clearable placeholder="请选择">
                    <el-option v-for="item in customerOptions" :key="item.ORMTB410ID" :label="item.ORMTB410CA00"
                      :value="item.ORMTB410ID">
                    </el-option>
                  </el-select>
                </div>
                <div class="public_oparetionBlock_Menu">
                  <label class="public_lbSty">是否结清：</label>
                  <el-select class="public_optionSty dropDown_Define" v-model="dayRecord.ORMTB620CA12" placeholder="请选择"
                    clearable>
                    <el-option v-for="item in jqOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div class="public_oparetionBlock_Menu">
                  <label class="public_lbSty">账单状态：</label>
                  <el-select class="public_optionSty dropDown_Define" v-model="dayRecord.ORMTB620CA08" placeholder="请选择"
                    clearable>
                    <el-option v-for="item in zdOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="customerManagementPC-btn public_operatBtn" style="margin-left: 0px;">
                <el-button class="public_saleWater_chaxun" type="primary" @click="queryCustomerRecords">
                  <i class="iconfont icon-chaxun"></i>查询
                </el-button>
              </div>
            </div>
            <div class="salesWatersStatisticsPC-saleWaterDetails-table pulbic_table_container">
              <el-table :data="customerBillList" style="width: 100%" stripe class="public_tableColumn"
                :header-cell-style="{
                  'font-family': 'Microsoft YaHei',
                  'font-weight': 'bold',
                  color: 'rgba(51,51,51,1)',
                }">
                <el-table-column prop="ormtb410CA00" label="客户名称">
                </el-table-column>
                <el-table-column prop="ormtb620CA20" label="账单日报">
                </el-table-column>
                <el-table-column prop="ormtb620ca05" label="账单金额(元)">
                </el-table-column>
                <el-table-column prop="ormtb620ca06" label="已还本金(元)">
                </el-table-column>
                <el-table-column prop="ormtb620ca07" label="待还本金(元)">
                </el-table-column>
                <el-table-column prop="ormtb620ca10" label="违约天数">
                </el-table-column>
                <el-table-column prop="ormtb620ca09" label="违约金">
                </el-table-column>
                <el-table-column prop="ormtb620ca11" label="已还违约金">
                </el-table-column>
                <el-table-column prop="ormtb620ca12" label="是否结清">
                  <template slot-scope="scope">
                    <span style="color:red;" v-if="scope.row.ormtb620ca12 == '0'">未结清</span>
                    <span style="color:green;" v-else>已结清</span>
                  </template>
                </el-table-column>
                <el-table-column prop="ormtb620ca13" label="结清时间">
                </el-table-column>
                <el-table-column prop="ormtb620ca08" label="账单状态">
                  <template slot-scope="scope">
                    <span class="activeGreen" v-if="scope.row.ormtb620ca08 == '0'">履约</span>
                    <span class="activeRed" v-else>违约</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button class="public_icon_qiyong public_icon_width public_icon_margin" size="small"
                      @click="repaymentRecordClick(scope.row)">还款记录
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="billOperationRecord-page">
              <el-pagination @size-change="handleSizeChangeBill" @current-change="handleCurrentChangeBill"
                :current-page.sync="currentPageBill" :page-sizes="[10, 20, 30, 40]" :page-size="billPageSize"
                layout="total,sizes, prev, pager, next" :total="billTotal">
              </el-pagination>
            </div>
          </div>
        </el-dialog>
      </div>
      <!-- 还款记录 -->
      <div class="public-dialog">
        <el-dialog title="客户还款记录" :visible.sync="customerRepaymentShow" width="60%" :closeOnClickModal="false">
          <div class="salesWatersStatisticsPC-saleWaterDetails">
            <div class="customerBillTable">
              <div class="public_criteriaRange customerManagementPC-select">
                <div class="">
                  <label class="public_lbSty">客户名称：</label>
                  <span>{{ recordCustomerName }}</span>
                </div>
              </div>
            </div>
            <div class="salesWatersStatisticsPC-saleWaterDetails-table pulbic_table_container">
              <el-table :data="customerRepaymentList" style="width: 100%" stripe class="public_tableColumn"
                :header-cell-style="{
                  'font-family': 'Microsoft YaHei',
                  'font-weight': 'bold',
                  color: 'rgba(51,51,51,1)',
                }">
                <el-table-column prop="ormtb621ca01" label="还款时间">
                </el-table-column>
                <el-table-column prop="ormtb620CA05" label="账单金额(元)">
                </el-table-column>
                <el-table-column prop="ormtb621ca02" label="已还本金(元)">
                </el-table-column>
                <el-table-column prop="ormtb621ca03" label="待还本金(元)">
                </el-table-column>
                <el-table-column prop="ormtb621ca04" label="已还违约金">
                </el-table-column>
                <el-table-column prop="ormtb621ca05" label="待还违约金">
                </el-table-column>
              </el-table>
            </div>
            <div class="billOperationRecord-page">
              <el-pagination @size-change="handleSizeChangeRepayment" @current-change="handleCurrentChangeRepayment"
                :current-page.sync="currentPageRepayment" :page-sizes="[10, 20, 30, 40]" :page-size="repaymentPageSize"
                layout="total,sizes, prev, pager, next" :total="repaymentTotal">
              </el-pagination>
            </div>
          </div>
        </el-dialog>
      </div>
      <!-- 授信记录 -->
      <div class="public-dialog">
        <el-dialog :title="sxtitle" :visible.sync="customerCreditShow" width="80%" :closeOnClickModal="false">
          <div class="salesWatersStatisticsPC-saleWaterDetails">
            <div class="customerBillTable">
              <div class="public_criteriaRange customerManagementPC-select">
                <label class="public_lbSty" style="width: 120px;">筛选调整类型：</label>
                <div style="display: flex;">
                  <el-select class="public_optionSty dropDown_Define" style="margin-right: 5px;" v-model="tzlx"
                    clearable placeholder="请选择">
                    <el-option v-for="(item, index) in tzOptions" :key="index" :label="item.name" :value="item.type">
                    </el-option>
                  </el-select>
                  <div class="inputBox">
                    <RangeInputAdvanced v-model="range" show-tips />
                  </div>
                </div>
                <div style="margin-left: 20px;">
                  <label class="public_lbSty">筛选调整时间：</label>
                  <el-date-picker v-model="tzsj" type="datetimerange" range-separator="至" start-placeholder="开始日期"
                    end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
              </div>
              <div class="customerManagementPC-btn public_operatBtn" style="margin-left: 20px;">
                <el-button class="public_saleWater_chaxun" type="primary" @click="queryCustomerCredit">
                  <i class="iconfont icon-chaxun"></i>查询
                </el-button>
              </div>
            </div>
            <div class="salesWatersStatisticsPC-saleWaterDetails-table pulbic_table_container">
              <el-table :data="customerCreditList" style="width: 100%" stripe class="public_tableColumn"
                :header-cell-style="{
                  'font-family': 'Microsoft YaHei',
                  'font-weight': 'bold',
                  color: 'rgba(51,51,51,1)',
                }">
                <el-table-column prop="ORMTB410CA00" label="客户">
                </el-table-column>
                <el-table-column prop="creditStatus" label="授信状态">
                  <template slot-scope="scope">
                    <span v-if="scope.row.creditStatus == 0">禁用</span>
                    <span v-if="scope.row.creditStatus == 1">启用</span>
                  </template>
                </el-table-column>
                <el-table-column prop="creditAmt" label="授信金额(元)">
                </el-table-column>
                <el-table-column prop="creditUsableStatus" label="可用余额启用/禁用">
                  <template slot-scope="scope">
                    <span v-if="scope.row.creditUsableStatus == 0">禁用</span>
                    <span v-if="scope.row.creditUsableStatus == 1">启用</span>
                  </template>
                </el-table-column>
                <el-table-column prop="repayNum" label="还款天数(元)">
                </el-table-column>
                <el-table-column prop="dailyPaper" label="日报推送">
                </el-table-column>
                <el-table-column prop="deditRatio" label="收取违约金(‰)">
                  <template slot-scope="scope">
                    <span>{{ scope.row.deditRatio }}</span><span v-if="scope.row.deditRatio">‰</span>
                  </template>
                </el-table-column>
                <el-table-column prop="createDateTime" label="调整时间">
                </el-table-column>
                <el-table-column prop="operator" label="操作人">
                </el-table-column>
              </el-table>
            </div>
            <div class="billOperationRecord-page">
              <el-pagination @size-change="handleSizeChangeCredit" @current-change="handleCurrentChangeCredit"
                :current-page.sync="currentPageCredit" :page-sizes="[10, 20, 30, 40]" :page-size="creditPageSize"
                layout="total,sizes, prev, pager, next" :total="creditTotal">
              </el-pagination>
            </div>
          </div>
        </el-dialog>
      </div>
      <!-- 授信设置 -->
      <div class="public-dialog">
        <el-dialog title="客户授信设置" :visible.sync="creditShow" width="30%" :before-close="cancelCredit"
          :closeOnClickModal="false">
          <div>
            <div style="padding-left: 20px;margin-bottom: 10px;">
              <span style="vertical-align: middle;margin-right: 10px;">客户授信: </span><el-switch v-model="creditStatus"
                active-text="开启授信" inactive-text="关闭授信" @change="updateCreditStatus" :active-value="1"
                :inactive-value="0">
              </el-switch>
            </div>
            <div class="customerManagementPC-add-customer">
              <div class="customerManagementPC-add-customer-li">
                <div class="customerManagementPC-add-customer-li-name">
                  客户名称:
                </div>
                <div class="customerManagementPC-add-customer-li-ipt">
                  <input readonly v-model="creditObj.ORMTB410CA00" />
                </div>
                <div class="customerManagementPC-add-customer-li-type">
                  *必填*
                </div>
              </div>
              <div class="customerManagementPC-add-customer-li">
                <div class="customerManagementPC-add-customer-li-name">
                  联系电话:
                </div>
                <div class="customerManagementPC-add-customer-li-ipt">
                  <input readonly v-model="creditObj.ORMTB410CA02" />
                </div>
                <div class="customerManagementPC-add-customer-li-type">
                  *必填*
                </div>
              </div>
              <div class="customerManagementPC-add-customer-li">
                <div class="customerManagementPC-add-customer-li-name">
                  授信金额:
                </div>
                <div class="customerManagementPC-add-customer-li-ipt">
                  <input type="text" v-model="creditObj.creditAmt" :disabled="!creditStatus"
                    @input="creditObj.creditAmt = formatNumber(creditObj.creditAmt)" />
                </div>
                <div class="customerManagementPC-add-customer-li-type">
                  元*必填*
                </div>
              </div>
              <div class="customerManagementPC-add-customer-li">
                <div class="customerManagementPC-add-customer-li-name">
                  授信可用金额:
                </div>
                <div class="customerManagementPC-add-customer-li-ipt">
                  <el-switch v-model="creditObj.creditUsableStatus" :disabled="!creditStatus" :active-value="1"
                    :inactive-value="0" active-text="启用" inactive-text="停用">
                  </el-switch>
                </div>
                <div class="customerManagementPC-add-customer-li-type">
                  *必填*
                </div>
              </div>
              <div class="customerManagementPC-add-customer-li">
                <div class="customerManagementPC-add-customer-li-name">
                  还款天数:
                </div>
                <div class="customerManagementPC-add-customer-li-ipt">
                  <input type="number" v-model="creditObj.repayNum" :disabled="!creditStatus"
                    @input="creditObj.repayNum = $event.target.value ? parseInt($event.target.value, 10) : ''" step="1"
                    min="0" />
                </div>
                <div class="customerManagementPC-add-customer-li-type">
                  天*必填*
                </div>
              </div>
              <div class="customerManagementPC-add-customer-li">
                <div class="customerManagementPC-add-customer-li-name">
                  日报推送:
                </div>
                <div class="customerManagementPC-add-customer-li-ipt">
                  <CustomTimePicker v-model="creditObj.dailyPaper" :disabled="creditStatus" />
                </div>
                <div class="customerManagementPC-add-customer-li-type">
                  *必填*
                </div>
              </div>
              <div class="customerManagementPC-add-customer-li">
                <div class="customerManagementPC-add-customer-li-name">
                  违约金收取:
                </div>
                <div class="customerManagementPC-add-customer-li-ipt">
                  <input v-model="creditObj.deditRatio"
                    @input="creditObj.deditRatio = formatNumber(creditObj.deditRatio)" :disabled="!creditStatus" />
                </div>
                <div class="customerManagementPC-add-customer-li-type">
                  ‰*必填*
                </div>
              </div>
              <div style="margin-top: 10px;">
                <div class="textColor">日报推送：账单日报以设置推送时间为节点，统计当日该时间点至次日同一时间范围内的授信使用数据，自动生成每日账单。</div>
                <div class="textColor">违约金收取：逾期未还款，每日按设定千分比例收取违约金。</div>
              </div>
              <div class="customerManagementPC-add-customer-btn">
                <el-button type="primary" :disabled="!creditStatus" @click="creditSave">保存</el-button>
                <el-button type="info" @click="cancelCredit">取消</el-button>
              </div>
            </div>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { Decimal } from 'decimal.js'
import CustomTimePicker from './components/customTimePicker.vue'
import RangeInputAdvanced from './components/RangeInputAdvanced.vue'
export default {
  components: {
    CustomTimePicker,
    RangeInputAdvanced
  },
  data() {
    return {
      row: {},
      selectIndex: '',
      cellClickColumn: '',
      customerManagementList: '',
      customerManagementValue: '',
      customerManagement: false,
      customerManagementAdd: false,
      customerManagementAddName: '',
      customerManagemenUPObj: '',
      customerManagementUpdate: false,
      cusQueryName: '',
      cusQueryiphone: '',
      sxkh: '',
      options: [],
      cusStatus: '',
      cusStatusList: [],
      tableData: [],
      flag: '',
      page: 1,
      pagesize: 10,
      currentPage: 1,
      count: 0,
      currentPage1: 1,
      detailsPageLimit: 10,
      detailsCount: 1,
      RechargetypeValue: '银行卡',
      RechargetypeOptions: [],
      hczhlxOptions: [{
        value: '0',
        label: '钱包余额',
      },
      {
        value: '1',
        label: '运费余额',
      }],
      hczhlxValue: '0',
      CZRecordsDetails: [],
      CZRecordsPage: 1,
      CZRecordsPageLimit: 10,
      CZRecordsCount: 0,
      tableDataDetails: [],
      offerDetailsTab: [],
      ORMTB411ID: '',
      CustomerfillingDig: false,
      wayTypeValue: '',
      wayTypeOptions: [
        {
          value: 'CW',
          label: '财务',
        },
        {
          value: 'XX',
          label: '线下',
        },
        {
          value: 'XS',
          label: '线上',
        },
      ],
      khdj: '全部',
      khdjOperation: [
        {
          value: '',
          label: '全部',
        },
        {
          value: '0301',
          label: '一级客户',
        },
        {
          value: '0302',
          label: '二级客户',
        },
        {
          value: '0303',
          label: '三级客户',
        },
        {
          value: '0304',
          label: '四级客户',
        },
        {
          value: '0305',
          label: '五级客户',
        },
        {
          value: '0306',
          label: '六级客户',
        },
        {
          value: '0307',
          label: '七级客户',
        },
        {
          value: '0308',
          label: '八级客户',
        },
        {
          value: '0309',
          label: '九级客户',
        },
      ],
      khxj: '',
      khxjOperation: [
        {
          value: '',
          label: '全部',
        },
        {
          value: '1',
          label: 'V1',
        },
        {
          value: '2',
          label: 'V2',
        },
        {
          value: '3',
          label: 'V3',
        },
        {
          value: '4',
          label: 'V4',
        },
        {
          value: '5',
          label: 'V5',
        },
      ],

      tableDatayh: [],
      multipleSelection: [],
      CZmoney: '',
      Czmaxlength: 10, //充值限额
      CZremark: '',
      HCmoney: '',
      HCremark: '',
      HCamountCapitalText: '',
      amountCapitalText: '',
      cusInsertShow: false,
      yhInsertShow: false,
      ykblInsertShow: false,
      rowSelectFlag: false, // 禁止toggleRowSelection默认触发  @selection-change
      allChek: false,
      ruleForm: {},
      rules: {
        ORMTB410CB17: [
          {
            required: true,
            message: '请输入客户比例',
            trigger: 'change',
          },
        ],
      },
      cusInsertObj: {
        ORMTB400ID: '',
        ORMTB410CA00: '',
        ORMTB410CA01: '',
        ORMTB410CA02: '',
        ORMTB410CA06: '',
      },
      cusUpdateShow: false,
      cusUpdateObj: {
        ORMTB400ID: '',
        ORMTB410CA00: '',
        ORMTB410CA01: '',
        ORMTB410CA02: '',
        ORMTB410CA06: '',
      },
      cusDJSetObj: {},
      freezeInsertShow: false,
      saleWaterDetails: false,
      rechargeTypeDig: false,
      rechargeTypeName: '',
      rechargeTypeUpOBJ: {
        SETTB206CA01: '',
      },
      rechargeTypeModifyDig: false,
      czRechargetypeShow: false,
      HCshow: false,
      HCObj: '',
      preferentialRecord: false,
      offerDetails: false,
      DetailsWater: false,
      deductionRecord: false,
      deductionRecordObj: '',
      deductionRecordtable: [],
      deductionRecordPage: 1,
      deductionRecordLimit: 10,
      deductionRecordCount: 0,
      DetailsWaterurl:
        'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
      DetailsWatersrcList: [
        'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
        'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg',
      ],

      // 物料信息
      materShow: false,
      materList: [],
      materiaShowZJ: '', //判断是否显示新增，修改，禁用按钮
      categoryMaterial: '', //物料类别
      nameMaterial: '', //物料名称
      pageMaterial: 1, //默认列表页码
      limitMaterial: 10, //每页的条数
      pagingPageMaterial: 0, //分页--数据列表共有的条数
      currentPageMaterial: 1, //设置当前页默认为1
      materialTypeList: [],
      cjmsgobj: {},

      //优惠调控
      discountShow: false,
      floatingType: '1', //浮动类型-上浮-下浮
      floatingAmount: '', //浮动金额
      disabled: true,

      useryhmsg: {},

      enterNameMaterialModify: '', //企业名称
      nameMaterialModify: '', //物料名称
      wholesalePriceModify: '', //零售价格
      preferentialType: 0,
      solelist: [],
      cusUDJSetpdateShow: false,
      tableDataGradePre: [],
      innerVisible: false,
      dgwlyh: '',
      dgwlyhOptions: [
        {
          value: 0,
          label: '是',
        },
        {
          value: 1,
          label: '否',
        },
      ],
      yhCjShow: false, //返点厂家弹窗
      cjList: [],
      wlObj: {
        wlName: '',
        wlId: '',
      },
      fdObj: {
        cjName: '',
        cjId: '',
        fdbl: '',
        wlName: '',
        wlId: '',
        wls: [],
        wlobjs: [],
        khName: '',
        khId: '',
        startTime: '',
        endTime: '',
      },
      wuliaoShow: false,

      fdmaterList: [],
      fdpageMaterial: 1, //默认列表页码
      fdlimitMaterial: 10, //每页的条数
      fdpagingPageMaterial: 0, //分页--数据列表共有的条数
      fdcurrentPageMaterial: 1, //设置当前页默认为1
      fdcjmsgobj: {},

      //含税价START
      hanshuijiaShow: false, //含税价弹窗
      hanshuijiaKG: false, //含税价开关
      objuserMsg: {}, //用户信息

      hsjstus: 0, //含税价状态

      hsjList: [],
      hsjListpageMaterial: 1, //默认列表页码
      hsjListlimitMaterial: 10, //每页的条数
      hsjListpagingPageMaterial: 0, //分页--数据列表共有的条数
      hsjcurrentPageMaterial: 1, //设置当前页默认为1

      ykhsjcjList: [],

      //含税价END

      //返点调控
      fandianShow: false,
      fdList: [],
      fdListpageMaterial: 1, //默认列表页码
      fdListlimitMaterial: 10, //每页的条数
      fdListpagingPageMaterial: 0, //分页--数据列表共有的条数
      wuliaoShowTj: false,
      fdListTj: [],
      fdListpagingPageMaterialTj: 0,
      fdListlimitMaterialTj: 10, //每页的条数
      fdpageMaterialTj: 1,
      fdlimitMaterialTj: 10,
      shouQuanChangJiaShow: false, //授权厂家弹窗
      checkAllCj: false,
      checkedCitiesName: [],
      isIndeterminateCj: false,
      factoryList: [],
      checkedCitiesId: [],
      customerId: '',
      kyyepx: '',
      kyyepxOperation: [
        {
          label: '全部',
          value: '',
        },
        {
          label: '正序',
          value: 'ORMTB410CA03 ASC',
        },
        {
          label: '倒序',
          value: 'ORMTB410CA03 DESC',
        },
      ],
      amountRecord: false,
      amountRecordList: [],
      currentPageAmount: 1,
      amountPageSize: 10,
      amountTotal: 0,
      multipleRecord: false,
      multipleRecordList: [],
      currentPageMultiple: 1,
      multiplePageSize: 10,
      multipleTotal: 0,
      customerBillShow: false,
      customerBillList: [],
      currentPageBill: 1,
      billPageSize: 10,
      billTotal: 0,
      customerRepaymentShow: false,
      customerRepaymentList: [],
      repaymentPageSize: 10,
      currentPageRepayment: 1,
      repaymentTotal: 0,
      customerCreditShow: false,
      customerCreditList: [],
      currentPageCredit: 1,
      creditPageSize: 10,
      creditTotal: 0,
      creditShow: false,
      selectedTime: null,
      // timeRangeDisplay: '',
      uobj: this.$store.state.uobj, //登陆缓存--用户信息
      creditObj: {
        ORMTB410ID: '',
        ORMTB410CA00: '',
        ORMTB410CA02: '',
        creditAmt: '',//授信金额
        repayNum: 7,//还款天数
        creditUsableStatus: 1,//可用状态
        deditRatio: '',//违约金比例
        dailyPaper: '',//日报推送
      },
      sxtitle: '授信记录',
      sxList: [],
      tzOptions: [
        {
          name: '授信金额',
          type: 'sxje'
        },
        {
          name: '还款天数',
          type: 'hkts'
        },
        {
          name: '收取违约金',
          type: 'sqwyj'
        }
      ],
      tzlx: '',//调整类型
      tzsj: '',//调整时间
      range: { min: null, max: null },
      useObj: {},
      jqOptions: [
        {
          label: '全部',
          value: null
        },
        {
          label: '已结清',
          value: 1
        },
        {
          label: '未结清',
          value: 0
        },
      ],
      zdOptions: [
        {
          label: '全部',
          value: null
        },
        {
          label: '违约',
          value: 1
        },
        {
          label: '履约',
          value: 0
        },
      ],
      dayRecord: {
        ORMTB410ID: '',
        ORMTB620CA12: null,
        ORMTB620CA08: null
      },
      customerOptions: [],
      recordCustomerId: '',
      recordCustomerName: '',
      zdje: '',
      ORMTB620ID: '',
      creditStatus: 0,
      firstCredit: 0,
    }
  },
  created() {
    var list = ''
    if (this.$route.query.mark != '' && this.$route.query.mark != null) {
      this.userobj = JSON.parse(sessionStorage.getItem('qpUobj'))
      list = JSON.parse(sessionStorage.getItem('qpSolelist'))
      sessionStorage.removeItem('qpUobj')
      sessionStorage.removeItem('qpSolelist')
      this.quanpDisabled = true
    } else {
      this.userobj = this.$store.state.uobj
      list = this.$store.state.solelist
      this.quanpDisabled = false
    }
    var path = this.$route.path
    if (path === '/SalesCustomer') {
      path = '/Home' + path
    }
    this.solelist = this.$baseAPI.querSoleList(list, path) //获取权限列表
    // console.log(this.solelist)
    // 赋值，缓存销毁
    this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl))
    sessionStorage.removeItem(this.currentUrl)
    if (this.historyInfo != null && this.historyInfo != '') {
      this.init()
    }
    // console.log(this.solelist)
    this.wayTypeValue = this.wayTypeOptions[0].value
    this.getcusList();
  },
  mounted() {
    this.querycusList()
    this.querypreferentialCode()
    this.khdjFun()
  },
  // 存储数据
  beforeDestroy() {
    var obj = {
      cusQueryName: this.cusQueryName, //客户名称
      cusQueryiphone: this.cusQueryiphone, //客户名称
      cusStatus: this.cusStatus, //客户状态
      currentPage: this.currentPage, //当前页数
      page: this.page, //页码
      pagesize: this.pagesize, //每页条数
    }
    sessionStorage.setItem(this.currentUrl, JSON.stringify(obj))
  },
  methods: {
    enterpriceSelect() {
      this.customerOptions = [{
        ORMTB410CA00: "全部",
        ORMTB410ID: ""
      }];
      // console.log(this.userobj)

      var data = {

      }
      if (this.userobj.pertb005.pertb005cb00 == "CUS-2") {
        data = {
          ORMTB400ID: this.userobj.ormtb410.ORMTB410ID //一级企业id
        }
      }
      if (this.userobj.pertb005.pertb005cb00 == "CUS-1") {
        data = {
          ORMTB400ID: this.userobj.ormtb400.ORMTB400ID //一级企业id
        }
      }

      var url1 = '/orm/ormtb420/selectOrmtb410CA00List'
      this.axios.post(url1, data).then(res => {
        // console.log(res)
        if (res.data.code == 200) {
          this.customerOptions = [...this.customerOptions, ...res.data.data]
        }
      }).catch(() => { })
    },
    formatNumber(value) {
      if (!value && value !== 0) return '';

      // 允许数字、小数点和负号
      let formatted = value.toString().replace(/[^\d.]/g, '');

      // 确保只有一个小数点，且最多两位小数
      const match = formatted.match(/^\d*\.?\d{0,2}/);
      if (match) {
        formatted = match[0];
      }

      // 如果格式化后是空或者只有小数点，返回原值（保留用户输入）
      if (formatted === '' || formatted === '.') {
        return value;
      }

      return formatted;
    },
    //获取授信客户列表
    getcusList() {
      var postData = {};
      if (this.uobj.pertb005.pertb005cb00 == "CUS-2") {
        postData = {
          ORMTB400ID: this.uobj.ormtb410.ORMTB400ID //一级企业id
        }
      }
      if (this.uobj.pertb005.pertb005cb00 == "CUS-1") {
        postData = {
          ORMTB400ID: this.uobj.ormtb400.ORMTB400ID //一级企业id
        }
      }
      this.axios
        .post('/orm/ormtb410/queryCreditCustomer', postData)
        .then(res => {
          if (res.data.code == 200) {
            this.sxList = res.data.data;
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {

        })
    },
    // 授信调整记录
    creditClick(row) {
      this.customerCreditShow = true;
      this.sxtitle = `${row.ORMTB410CA00}授信记录`;
      this.useObj = row;
      this.queryCustomerCredit();
    },
    // 账单记录
    billingRecordClick() {
      this.customerBillShow = true;
      this.enterpriceSelect();
      this.queryCustomerRecords();
    },
    //还款记录
    repaymentRecordClick(data) {
      this.customerRepaymentShow = true;
      this.recordCustomerId = data.ormtb410id;
      this.recordCustomerName = data.ormtb410CA00;
      this.zdje = data.ormtb620ca05;
      this.ORMTB620ID = data.ormtb620id;
      this.queryCustomerRepayment();
    },
    // 账单记录查询按钮
    queryCustomerRecords() {
      this.axios.post('/ormtb620/queryList', { ...this.dayRecord, page: this.currentPageBill, limit: this.billPageSize }).then(res => {
        if (res.data.code == 200) {
          this.customerBillList = res.data.data.records;
          this.billTotal = res.data.count;
        } else {
          this.$message({
            message: res.data.message,
            type: 'error',
          })
        }
      })
    },
    // 还款记录查询按钮
    queryCustomerRepayment() {
      this.axios.post('/ormtb621/getPageOrmtb621', { ORMTB410ID: this.recordCustomerId, ORMTB620CA05: this.zdje, page: this.currentPageRepayment, limit: this.repaymentPageSize, ORMTB620ID: this.ORMTB620ID }).then(res => {
        if (res.data.code == 200) {
          this.customerRepaymentList = res.data.data;
          this.repaymentTotal = res.data.count;
        } else {
          this.$message({
            message: res.data.message,
            type: 'error',
          })
        }
      })
    },
    // 授信记录查询
    queryCustomerCredit() {
      let queryData = {};
      if (this.tzlx) {
        if (!this.range.min || !this.range.max) {
          this.$message({
            message: '请输入最小值、最大值',
            type: 'warning',
          })
          return;
        }
      }
      if (this.tzlx == 'sxje') {
        queryData.startCreditAmt = this.range.min;
        queryData.endCreditAmt = this.range.max;
      } else if (this.tzlx == 'hkts') {
        queryData.startRepayNum = this.range.min;
        queryData.endRepayNum = this.range.max;
      } else if (this.tzlx == 'sqwyj') {
        queryData.startDeditRatio = this.range.min;
        queryData.endDeditRatio = this.range.max;
      }
      queryData.startTime = this.tzsj ? this.tzsj[0] : '';
      queryData.endTime = this.tzsj ? this.tzsj[1] : '';
      this.axios.post('/orm/creditRecord/queryList', { ...queryData, page: this.currentPageCredit, limit: this.creditPageSize, ORMTB410ID: this.useObj.ORMTB410ID }).then(res => {
        if (res.data.code == 200) {
          this.customerCreditList = res.data.data;
          this.creditTotal = res.data.count;
        } else {
          this.$message({
            message: res.data.message,
            type: 'error',
          })
        }
      })
    },
    updateCreditStatus(e, cancleStatus) {
      this.axios.post('/orm/ormtb410/updateCreditStatus', {
        creditStatus: e,
        ORMTB410ID: this.creditObj.ORMTB410ID
      }).then(res => {
        if (res.data.code == 200) {
          this.querycusList();
          this.$message({
            message: res.data.message,
            type: 'success',
          })
          if (cancleStatus == 1) {//首次授信、没有填写信息，点击取消按钮
            this.creditShow = false;
            this.selectedTime = '';
          }
        } else {
          // 接口返回失败（包括校验不通过），恢复开关状态
          this.creditStatus = e === 1 ? 0 : 1;
          this.$message({
            message: res.data.message,
            type: 'error',
          })
        }
      }).catch(error => {
        // 请求异常，恢复开关状态
        this.creditStatus = e === 1 ? 0 : 1;
        this.$message({
          message: '操作失败：' + (error.message || '请稍后重试'),
          type: 'error',
        })
      })
    },
    // 授信弹窗
    openCredit(data) {
      this.creditShow = true;
      this.firstCredit = data.firstCredit;
      this.creditStatus = data.creditStatus;
      this.creditObj.ORMTB410ID = data.ORMTB410ID;
      this.creditObj.ORMTB410CA00 = data.ORMTB410CA00;
      this.creditObj.ORMTB410CA02 = data.ORMTB410CA02;
      this.creditObj.creditAmt = data.creditAmt;
      this.creditObj.repayNum = data.repayNum;
      this.creditObj.deditRatio = data.deditRatio;
      this.creditObj.dailyPaper = data.dailyPaper;
      this.creditObj.creditUsableStatus = data.creditUsableStatus;
    },
    // 客户授信设置保存
    creditSave() {
      if (this.creditObj.creditAmt === '') {
        return this.$message.warning('请输入授信金额');
      }
      if (this.creditObj.repayNum === undefined || this.creditObj.repayNum === '') {
        return this.$message.warning('请输入还款天数');
      }
      if (this.creditObj.dailyPaper === undefined || this.creditObj.dailyPaper === '') {
        return this.$message.warning('请输入日报推送时间');
      }
      if (this.creditObj.deditRatio === undefined || this.creditObj.deditRatio === '') {
        return this.$message.warning('请输入违约金比例');
      }
      this.axios
        .post('/orm/ormtb410/updateCreditSet', this.creditObj)
        .then(res => {
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: 'success',
            })
            this.creditShow = false;
            this.querycusList();
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {

        })
    },
    cancelCredit() {
      if (this.creditStatus) {
        if (this.firstCredit) {
          this.creditShow = false;
          this.selectedTime = '';
        } else {
          this.updateCreditStatus(0, 1);
        }
      } else {
        this.creditShow = false;
        this.selectedTime = '';
      }

    },
    openAmount() {
      this.amountRecord = true;
      this.currentPageAmount = 1;
      this.getRecords(2, this.currentPageAmount, this.amountPageSize);
    },
    openMultiple() {
      this.multipleRecord = true;
      this.currentPageMultiple = 1;
      this.getRecords(1, this.currentPageMultiple, this.multiplePageSize);
    },
    // 获取修改记录
    getRecords(type1, page, limit) {
      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = {
        ORMTB410ID: this.cusDJSetObj.ORMTB410ID,
        type: type1,
        page: page,
        limit: limit
      }
      var url = 'orm/ormtb410/selectDJHistory'
      this.axios
        .post(url, postData)
        .then(res => {
          setTimeout(() => {
            loading.close()
          }, 300)
          if (res.data.code == 200) {
            if (type1 == 2) {
              this.amountRecordList = res.data.data
              this.amountTotal = res.data.count
            } else {
              this.multipleRecordList = res.data.data
              this.multipleTotal = res.data.count
            }
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },
    // 授权厂家弹窗确定
    preservationModify() {
      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      let names = this.checkedCitiesName.join(',')
      let ids = this.checkedCitiesId.join(',')
      var postData = {
        ORMTB706CA01: ids,
        ORMTB706CA04: names,
        ORMTB706CA00: this.customerId,
      }
      var url = 'orm/ormtb706/insertOrUpdate'
      this.axios
        .post(url, postData)
        .then(res => {
          setTimeout(() => {
            loading.close()
          }, 300)
          if (res.data.code == 200) {
            this.shouQuanChangJiaShow = false
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },
    // 授权厂家弹窗取消
    cancelModify() {
      this.shouQuanChangJiaShow = false
    },
    handlecheckedCitiesNameChange(value) {
      //授权厂家单选
      let checkedCount = value.length
      this.checkAllCj = checkedCount === this.factoryList.length
      this.isIndeterminateCj =
        checkedCount > 0 && checkedCount < this.factoryList.length
      this.checkedCitiesId = this.factoryList
        .filter(item => value.includes(item.SETTB99CA00))
        .map(item => item.SETTB99ID)
    },
    handlecheckAllCjChange(val) {
      //授权厂家全选
      if (val) {
        for (let i = 0; i < this.factoryList.length; i++) {
          this.checkedCitiesName.push(this.factoryList[i].SETTB99CA00)
          this.checkedCitiesId.push(this.factoryList[i].SETTB99ID)
        }
      } else {
        this.checkedCitiesName = []
        this.checkedCitiesId = []
      }
      this.isIndeterminateCj = false
    },
    dgwlyhFun(e) {
      console.log(e)
      this.dgwlyh = e
    },

    onSortChange({ prop, order }) {
      // console.log(order)
      if (prop == 'ORMTB410CA06') {
        this.tableData.sort(this.compare(prop, order))
      }
    },
    rowClassName({ row, rowIndex }) {
      // 点击时 添加小手样式
      if (rowIndex === rowIndex) {
        return 'addPointer'
      }
    },

    rowClick(row, column, event) {
      console.log(row)
      this.selectIndex = row.ORMTB400ID
      console.log(this.selectIndex)
      if (row.ORMTB400ID == this.selectIndex) {
        console.log(1)
        return 'success-row'
      }
    },

    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          // console.log(row)
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    // 回显选中的数据
    selectData() {
      this.$nextTick(() => {
        // this.rowSelectFlag = true
        this.tableDatayh.forEach(row => {
          // console.log(row)
          if (row.SETTB414ID) {
            this.multipleSelection.push(row)
            // console.log('111')
            this.$refs.multipleTable.toggleRowSelection(row, true)
          }
          // this.rowSelectFlag = false
        })
      })
    },
    handleSelectionChange(val) {
      // console.log(val)
      // if (this.rowSelectFlag) return
      this.multipleSelection = val
    },

    // 新增保存
    preservationAdd(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.postAdd()
          // this.$refs[formName].resetFields();
        } else {
          console.log(1)

          // 			if (this.checkedCitiesGrade.length == 0) {
          // 				this.$message({
          // 					message: '请选择客户等级',
          // 					type: 'error'
          // 				});

          // 			} else if (this.checkedCitiesName.length == 0) {
          // 				this.$message({
          // 					message: '请选择可获得优惠券厂家',
          // 					type: 'error'
          // 				});
          // 			} else if (this.checkedCitiesSycj.length == 0) {
          // 				this.$message({
          // 					message: '请选择可使用优惠券厂家',
          // 					type: 'error'
          // 				});
          // 			}
          return false
        }
      })
    },
    // 油卡比例调用接口
    postAdd() {
      // console.log(newArrKhdj)
      // console.log(newArrHdcjId)
      // console.log(newArrHdcjName)
      // return
      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = {
        ORMTB410ID: this.ruleForm.ORMTB410ID, //ID
        ORMTB410CB17: this.ruleForm.ORMTB410CB17,
      }
      var url = '/orm/ormtb410/updateORMTB410CB17'
      this.axios
        .post(url, postData)
        .then(res => {
          // console.log(res)
          if (res.data.code == 200) {
            this.$message({
              message: '成功',
              type: 'success',
            })
            this.ykblInsertShow = false
            this.querycusList()
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
          setTimeout(() => {
            loading.close()
          }, 100)
        })
        .catch(() => {
          loading.close()
        })
    },

    MaterialQuery() {
      this.pageMaterial = 1
      this.pageMaterialList()
    },
    DiscountModify(item) {
      console.log(item)
      this.discountShow = true
      // this.queryMaterialTypeLsit('')
      this.MaterialModify109ID = item.SETTB109ID //物料ID
      this.enterNameMaterialModify = item.SETTB99CA00 //企业名称
      this.nameMaterialModify = item.SETTB109CA00 //物料名称
      this.selectuserByPer()
    },
    //查询物料信息
    queryMaterialTypeLsit() {
      // console.log(type)
      // if (type === 0) {
      // 	this.materialTypeList = [{
      // 		SETTB206CA00: "",
      // 		SETTB206CA01: "全部"
      // 	}];
      // }
      // else {
      // 	this.materialTypeList = []
      // }
      this.materialTypeList = [
        {
          SETTB206CA00: '',
          SETTB206CA01: '全部',
        },
      ]
      var url = '/set/settb109/selectSETTB206CA01'
      this.axios.get(url).then(res => {
        // console.log(res)
        if (res.data.code == 200) {
          var data = res.data.data
          this.materialTypeList = [...this.materialTypeList, ...data]
          // if (type === 0) {
          // 	this.materialTypeList = [...this.materialTypeList, ...data];
          // } else {
          // 	this.materialTypeList = data
          // }
        } else {
          this.$message({
            message: res.data.message,
            type: 'error',
          })
        }
      })
    },

    //用户单个物料优惠调控
    selectuserByPer() {
      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = {
        ORMTB410ID: this.rowkhId,
        SETTB109ID: this.MaterialModify109ID, //物料ID
      }
      var url = '/set/settb109/selectByPer'
      this.axios
        .post(url, postData)
        .then(res => {
          // console.log(res)
          if (res.data.code == 200) {
            console.log(res)

            if (res.data.data) {
              this.floatingAmount = res.data.data.SETTB418CA07 //浮动金额
              this.floatingType = JSON.stringify(res.data.data.SETTB418CA06) //浮动类型-上浮/下调
            } else {
              this.floatingAmount = '' //浮动金额
              this.floatingType = '' //浮动类型-上浮/下调
            }

            // this.$message({
            // 	message: res.data.message,
            // 	type: 'success'
            // });
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
          setTimeout(() => {
            loading.close()
          }, 300)
        })
        .catch(() => {
          loading.close()
        })
    },

    preservationDiscountModify() {
      if (this.floatingType === '') return this.$message.error('请选择浮动类型')
      if (this.floatingAmount == undefined)
        return this.$message.error('请输入浮动金额')

      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = {
        // SETTB99CA00: this.enterNameMaterialModify, //二级企业名称
        ORMTB410ID: this.rowkhId,
        SETTB109ID: this.MaterialModify109ID, //物料ID
        SETTB418CA06: this.floatingType, //上浮-下浮
        SETTB418CA07: this.floatingAmount, //浮动金额
      }
      var url = '/set/settb109/updateByPer'
      this.axios
        .post(url, postData)
        .then(res => {
          // console.log(res)
          if (res.data.code == 200) {
            this.discountShow = false
            this.$message({
              message: res.data.message,
              type: 'success',
            })
            this.pageMaterialList()
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
          setTimeout(() => {
            loading.close()
          }, 300)
        })
        .catch(() => {
          loading.close()
        })
    },

    // 列表
    pageMaterialList() {
      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = {
        SETTB109CA03: this.categoryMaterial, //物料类别
        SETTB109CA00: this.nameMaterial, //物料名称
        // SETTB109CD01: this.cjmsgobj.SETTB414CA01, //一级企业id
        SETTB99ID: this.cjmsgobj.SETTB414CA01, //二级企业ID
        ORMTB410ID: this.rowkhId,
        // ORMTB401CA01: this.materiaShowZJ, //企业是绑定还是自建
        page: this.pageMaterial,
        limit: this.limitMaterial,
      }
      this.materList = []
      var moList
      var url = '/set/settb109/selectPageListByCo'
      this.axios
        .post(url, postData)
        .then(res => {
          // console.log(res)
          setTimeout(() => {
            loading.close()
          }, 300)
          if (res.data.code == 200) {
            moList = res.data.data

            this.materList = moList
            this.pagingPageMaterial = res.data.count
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },
    handleSizeChangeMaterial(val) {
      this.pageMaterial = 1
      this.limitMaterial = val
      this.pageMaterialList()
    },
    // 点击页码
    handleCurrentChangeMaterial(val) {
      this.pageMaterial = val
      this.pageMaterialList()
    },

    slmsgClick(row) {
      this.materShow = true
      this.cjmsgobj = row
      console.log(row)

      this.queryMaterialTypeLsit()
      this.pageMaterialList()
    },

    //提交客户优惠信息
    khyhserve() {
      if (this.multipleSelection.length == 0) {
        this.$message({
          message: '请选择数据',
          type: 'error',
        })
        return
      }

      var url = '/set/settb414/save'
      var loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = {
        ORMTB410ID: this.rowkhId,
        list: this.multipleSelection,
      }
      this.axios
        .post(url, postData)
        .then(res => {
          // console.log(res)
          if (res.data.code == 200) {
            // console.log(res)
            this.yhInsertShow = false
            this.multipleSelection = []
            // this.$message({
            // 	message: res.data.message,
            // 	type: 'error'
            // });
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
          setTimeout(() => {
            loading.close()
          }, 300)
        })
        .catch(() => {
          loading.close()
        })
    },
    khyhqx() {
      this.$refs.multipleTable.clearSelection()
      this.yhInsertShow = false
      this.multipleSelection = []
    },

    compare(propertyName, sort) {
      return function (obj1, obj2) {
        var value1 = obj1[propertyName]
        var value2 = obj2[propertyName]
        // console.log(value2)

        if (typeof value1 === 'string' && typeof value2 === 'string') {
          const res = value1.localeCompare(value2)
          return sort === 'ascending' ? res : -res
        } else {
          // if (value1 <= value2) {
          // 	return sort === "ascending" ? -1 : 1;
          // } else if (value1 > value2) {
          // 	return sort === "ascending" ? 1 : -1;
          // }
        }
      }
    },

    // 账号的启用和禁用
    updateUserStatus(item) {
      var url = '/orm/ormtb410/updateUserStatus'
      var postData = {
        ORMTB410ID: item.ORMTB410ID,
        ORMTB410CA02: item.ORMTB410CA02, // 手机号
        ORMTB410CB00: item.ORMTB410CB00 == 1 ? '0' : '1', //状态 启用传1，禁用传0
      }
      var loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      this.axios
        .post(url, postData)
        .then(res => {
          // console.log(res)
          if (res.data.code == 200) {
            this.querycusList()
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
          setTimeout(() => {
            loading.close()
          }, 300)
        })
        .catch(() => {
          loading.close()
        })
    },
    // 线上结算方式
    updateYfStatus(item) {
      var url = '/orm/ormtb410/updateORMTB410CB10'
      var postData = {
        ORMTB410ID: item.ORMTB410ID,
        ORMTB410CB10: item.ORMTB410CB10 == 1 ? '0' : '1', //状态 启用传1，禁用传0
      }
      var loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      this.axios
        .post(url, postData)
        .then(res => {
          // console.log(res)
          if (res.data.code == 200) {
            this.querycusList()
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
          setTimeout(() => {
            loading.close()
          }, 300)
        })
        .catch(() => {
          loading.close()
        })
    },
    // 是否开启延迟结算运费
    updateycjsStatus(item) {
      var url = '/orm/ormtb410/updateORMTB410CB24'
      var postData = {
        ORMTB410ID: item.ORMTB410ID,
        ORMTB410CB24: item.ORMTB410CB24 == 1 ? '0' : '1', //状态 启用传1，关闭传0
      }
      var loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      this.axios
        .post(url, postData)
        .then(res => {
          // console.log(res)
          if (res.data.code == 200) {
            this.querycusList()
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
          setTimeout(() => {
            loading.close()
          }, 300)
        })
        .catch(() => {
          loading.close()
        })
    },
    //发票开启关闭
    updatefpfStatus(item) {
      var url = '/orm/ormtb410/updateORMTB410CB18'
      var postData = {
        ORMTB410ID: item.ORMTB410ID,
        ORMTB410CB18: item.ORMTB410CB18 == 1 ? '0' : '1', //状态 启用传1，关闭传0
      }
      var loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      this.axios
        .post(url, postData)
        .then(res => {
          // console.log(res)
          if (res.data.code == 200) {
            this.querycusList()
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
          setTimeout(() => {
            loading.close()
          }, 300)
        })
        .catch(() => {
          loading.close()
        })
    },

    //发票开启关闭
    updateslqxStatus(item) {
      var url = '/orm/ormtb410/updateORMTB410CB21'
      var postData = {
        ORMTB410ID: item.ORMTB410ID,
        ORMTB410CB21: item.ORMTB410CB21 == 1 ? '0' : '1', //状态 启用传1，关闭传0
      }
      var loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      this.axios
        .post(url, postData)
        .then(res => {
          // console.log(res)
          if (res.data.code == 200) {
            this.querycusList()
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
          setTimeout(() => {
            loading.close()
          }, 300)
        })
        .catch(() => {
          loading.close()
        })
    },

    // 下单的限制和解除限制
    updateUserLimitStatus(item) {
      var url = '/orm/ormtb410/updateORMTB410CB01'
      var postData = {
        ORMTB410ID: item.ORMTB410ID,
        // ORMTB410CA02: item.ORMTB410CA02, // 手机号
        ORMTB410CB01: item.ORMTB410CB01 == 1 ? '0' : '1', //状态 启用传1，禁用传0
      }
      var loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      this.axios
        .post(url, postData)
        .then(res => {
          // console.log(res)
          if (res.data.code == 200) {
            this.querycusList()
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
          setTimeout(() => {
            loading.close()
          }, 300)
        })
        .catch(() => {
          loading.close()
        })
    },

    //初始化数据
    init() {
      this.cusQueryName = this.historyInfo.cusQueryName
      this.cusQueryiphone = this.historyInfo.cusQueryiphone
      this.currentPage = this.historyInfo.currentPage
      this.page = this.historyInfo.page
      this.pagesize = this.historyInfo.pagesize
      this.cusStatus = this.historyInfo.cusStatus
    },
    fullScreen() {
      //全屏
      var mark = 1
      sessionStorage.setItem(
        'qpSolelist',
        JSON.stringify(this.$store.state.solelist)
      )
      sessionStorage.setItem('qpUobj', JSON.stringify(this.$store.state.uobj))

      let Logistics = this.$router.resolve({
        path: '/SalesCustomer',
        query: {
          mark: mark,
        },
      })
      this.$baseAPI.requestFullScreen(Logistics)
    },
    querycusList(dataFlag) {
      this.tableData = []
      this.flag = dataFlag
      if (this.khdj == '全部') {
        this.khdj = ''
      }
      // this.count =0
      var url = '/orm/ormtb410/selectPageList'
      if (dataFlag) {
        this.page = ''
        this.pagesize = ''
      }
      var postData = {
        ORMTB400ID: this.userobj.ormtb400.ORMTB400ID,
        ORMTB410CA00: this.cusQueryName, //客户名称
        ORMTB410CA02: this.cusQueryiphone, //客户手机号
        ORMTB410CA06: this.khdj, //客户等级
        ORMTB410CB02: this.khxj, //客户星级
        ORMTB410ID: this.sxkh,//授信客户
        COL: this.kyyepx, //可用余额
        flag: dataFlag, //查询所有客户全部展示
        page: this.page,
        limit: this.pagesize,
      }
      var loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      this.axios
        .post(url, postData)
        .then(res => {
          // console.log(res)
          if (res.data.code == 200) {
            this.tableData = res.data.data
            this.count = res.data.count
          }
          if (this.tableData.length > 0) {
            setTimeout(() => {
              loading.close()
            }, 300)
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
          setTimeout(() => {
            loading.close()
          }, 300)
        })
        .catch(() => {
          loading.close()
        })
    },
    freezeSetClick() {
      this.freezeInsertShow = true
      this.cusSelect()
    },
    khdjFun() {
      this.khdjOperation = []
      var List = [
        {
          SETTB206CA00: '',
          SETTB206CA01: '全部',
        },
      ]
      var url = '/set/settb500/selectLevel'
      // console.log(this.uobj)
      var postData = {
        // ORMTB400ID: this.uobj.ormtb400.ORMTB400ID, //一级代码ID
        // ORMTB400CA03: this.uobj.ormtb400.ORMTB400CA03, //一级客户代码
        // ORMTB410ID:this.objyh.ORMTB410ID,
        // SETTB99ID:this.enterpriseTwo//二级企业ID
      }

      var loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      this.axios
        .post(url, postData)
        .then(res => {
          // console.log(res)
          if (res.data.code == 200) {
            var data = res.data.data
            this.khdjOperation = [...List, ...data]
            // console.log(this.khdjOperation)
            // console.log(this.khdj)
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
          setTimeout(() => {
            loading.close()
          }, 300)
        })
        .catch(() => {
          loading.close()
        })
    },
    clearFun() {
      this.khdj = '全部'
    },
    cusSelect() {
      var url = '/orm/ormtb405/select'
      var loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      this.axios
        .post(url)
        .then(res => {
          // console.log(res)
          if (res.data.code == 200) {
            this.tableDataGradePre = res.data.data
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
          setTimeout(() => {
            loading.close()
          }, 300)
        })
        .catch(() => {
          loading.close()
        })
    },
    handleSizeChange(val) {
      this.pagesize = val
      this.page = 1
      this.querycusList()
    },
    handleCurrentChange(val) {
      this.page = val
      this.querycusList()
    },
    CZrecordClick(row) {
      // console.log(row)
      this.preferentialRecord = true
      var str = JSON.stringify(row)
      this.cusUpdateObj = JSON.parse(str)
      this.CZrecordQuery()
    },
    ykblFun(row) {
      console.log(row)
      this.ykblInsertShow = true
      this.ruleForm = row
    },
    resetForm(formName) {
      // console.log(formName)
      this.ykblInsertShow = false
      // this.$refs[formName].resetFields();
    },
    CZrecordQuery() {
      this.CZRecordsDetails = []
      // this.CZRecordsCount =0
      var url = '/orm/ormtb411/selectPageList'
      var loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = {
        ORMTB410ID: this.cusUpdateObj.ORMTB410ID,
        page: this.CZRecordsPage,
        limit: this.CZRecordsPageLimit,
      }
      this.axios
        .post(url, postData)
        .then(res => {
          // console.log(res)
          if (res.data.code == 200) {
            this.CZRecordsDetails = res.data.data
            this.CZRecordsCount = res.data.count
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
          setTimeout(() => {
            loading.close()
          }, 300)
        })
        .catch(() => {
          loading.close()
        })
    },
    offerDetailsClick(row) {
      this.offerDetails = true
      this.offerDetailsTab = []
      var url = '/orm/ormtb412/selectList'
      var loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = {
        ORMTB411ID: row.ORMTB411ID,
        SETTB206CD01: this.userobj.pertb005.pertb005cd01,
      }
      this.axios
        .post(url, postData)
        .then(res => {
          // console.log(res)
          if (res.data.code == 200) {
            this.offerDetailsTab = res.data.data
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
          setTimeout(() => {
            loading.close()
          }, 300)
        })
        .catch(() => {
          loading.close()
        })
    },
    deductionRecordClick(row) {
      // console.log(row)
      this.deductionRecordtable = []
      // this.deductionRecordCount=0
      var url = '/orm/ormtb413/selectPageList'
      var loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      this.ORMTB411ID = row.ORMTB411ID
      var postData = {
        ORMTB411ID: this.ORMTB411ID,
        page: this.deductionRecordPage,
        limit: this.deductionRecordLimit,
      }
      this.axios
        .post(url, postData)
        .then(res => {
          // console.log(res)
          if (res.data.code == 200) {
            this.deductionRecordtable = res.data.data
            this.deductionRecordCount = res.data.count
            this.deductionRecordtable.forEach(item => {
              if (item.ORMTB413CA02 == 'KK') {
                item.ORMTB413CA02Text = '扣款'
              } else if (item.ORMTB413CA02 == 'TK') {
                item.ORMTB413CA02Text = '退款'
              }
            })
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
          setTimeout(() => {
            loading.close()
          }, 300)
        })
        .catch(() => {
          loading.close()
        })
    },
    deductionRecordSizeChange(val) {
      this.deductionRecordLimit = val
      this.deductionRecordPage = 1
      this.deductionRecordClick()
    },
    deductionRecordCurrentChange(val) {
      this.deductionRecordPage = val
      this.deductionRecordClick()
    },
    queryWayTypeQuery() {
      this.tableDataDetails = []
      // this.detailsCount=0
      var url = '/set/settb206/selectPageList'
      var loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = {
        SETTB206CD01: this.userobj.ormtb400.ORMTB400CA03,
        SETTB205ID: '01',
        page: this.currentPage1,
        limit: this.detailsPageLimit,
      }
      this.axios
        .post(url, postData)
        .then(res => {
          // console.log(res)
          if (res.data.code == 200) {
            this.tableDataDetails = res.data.data
            this.detailsCount = res.data.count
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
          setTimeout(() => {
            loading.close()
          }, 300)
        })
        .catch(() => {
          loading.close()
        })
    },
    handleSizeChange1(val) {
      this.detailsPageLimit = val
      this.currentPage1 = 1
      // this.deductionRecordClick();
      this.queryWayTypeQuery()
    },
    handleCurrentChange1(val) {
      this.currentPage1 = val
      // this.deductionRecordClick();
      this.queryWayTypeQuery()
    },
    handleSizeChangeAmount(val) {
      this.amountPageSize = val
      this.currentPageAmount = 1
      this.getRecords(2, this.currentPageAmount, this.amountPageSize);
    },
    handleCurrentChangeAmount(val) {
      this.currentPageAmount = val;
      this.getRecords(2, this.currentPageAmount, this.amountPageSize);
    },
    handleSizeChangeMultiple(val) {
      this.multiplePageSize = val
      this.currentPageMultiple = 1
      this.getRecords(1, this.currentPageMultiple, this.multiplePageSize);
    },
    handleCurrentChangeMultiple(val) {
      this.currentPageMultiple = val
      this.getRecords(1, this.currentPageMultiple, this.multiplePageSize);
    },
    // 客户账单日报记录分页事件
    handleSizeChangeBill(val) {
      this.billPageSize = val
      this.currentPageBill = 1
      this.queryCustomerRecords();
      // this.getRecords(1, this.currentPageMultiple, this.multiplePageSize);
    },
    handleCurrentChangeBill(val) {
      this.currentPageBill = val;
      this.queryCustomerRecords();
      // this.getRecords(1, this.currentPageMultiple, this.multiplePageSize);
    },
    // 客户还款记录分页事件
    handleSizeChangeRepayment(val) {
      this.repaymentPageSize = val
      this.currentPageRepayment = 1
      this.queryCustomerRepayment();
      // this.getRecords(1, this.currentPageMultiple, this.multiplePageSize);
    },
    handleCurrentChangeRepayment(val) {
      this.currentPageRepayment = val
      this.queryCustomerRepayment();
      // this.getRecords(1, this.currentPageMultiple, this.multiplePageSize);
    },
    // 授信记录分页事件
    handleSizeChangeCredit(val) {
      this.creditPageSize = val
      this.currentPageCredit = 1
      this.queryCustomerCredit();
    },
    handleCurrentChangeCredit(val) {
      this.currentPageCredit = val
      this.queryCustomerCredit();
    },
    saleWaterDetailsclose() { },
    CustomerfillingDigClose() { },
    cusInsertClose() {
      ; (this.cusInsertObj = {
        ORMTB400ID: '',
        ORMTB410CA00: '',
        ORMTB410CA01: '',
        ORMTB410CA02: '',
        ORMTB410CA06: '',
      }),
        (this.multipleSelection = [])
    },
    cusInsertServe() {
      if (this.cusInsertObj.ORMTB410CA00.trim().length == 0)
        return this.$message.error('请输入客户名称')
      var reQ = /^1[3-9][0-9]{9}$/
      if (!reQ.test(this.cusInsertObj.ORMTB410CA02))
        return this.$message.error('请输入有效手机号')
      if (this.preferentialType == 1) {
        if (this.cusInsertObj.ORMTB410CA06.length == 0) {
          return this.$message.error('请选择客户等级')
        }
      }
      var url = '/orm/ormtb410/insertOrmtb410'
      var loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = this.cusInsertObj
      postData.ORMTB400ID = this.userobj.ormtb400.ORMTB400ID
      this.axios
        .post(url, postData)
        .then(res => {
          // console.log(res)
          if (res.data.code == 200) {
            this.$message.success('新增成功')
            this.querycusList()
            this.cusInsertShow = false
            this.cusInsertObj = {
              ORMTB400ID: '',
              ORMTB410CA00: '',
              ORMTB410CA01: '',
              ORMTB410CA02: '',
              ORMTB410CA06: '',
            }
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
          setTimeout(() => {
            loading.close()
          }, 300)
        })
        .catch(() => {
          loading.close()
        })
    },
    cusDJSetInsertServe() {
      var url = '/orm/ormtb405/update'
      var settb400List = []

      this.tableDataGradePre.forEach(resitme => {
        settb400List.push(resitme)
      })
      var postData = {
        list: settb400List,
      }
      var loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      this.axios
        .post(url, postData)
        .then(res => {
          // console.log(res)
          if (res.data.code == 200) {
            this.querycusList()
            this.$message({
              message: '提交成功',
              type: 'success',
            })
            this.freezeInsertShow = false
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
          setTimeout(() => {
            loading.close()
          }, 300)
        })
        .catch(() => {
          loading.close()
        })
    },
    upCusClose() {
      this.cusUpdateObj = {
        ORMTB400ID: '',
        ORMTB410CA00: '',
        ORMTB410CA01: '',
        ORMTB410CA02: '',
        ORMTB410CA06: '',
      }
      this.CZmoney = ''
      this.wayTypeValue = 'CW'
      this.amountCapitalText = ''
    },
    CZTypeQuery() {
      this.RechargetypeOptions = []
      var url =
        '/orm/ormtb411/selectCzType/' + this.userobj.ormtb400.ORMTB400CA03
      var loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      this.axios
        .get(url)
        .then(res => {
          // console.log(res)
          if (res.data.code == 200) {
            this.RechargetypeOptions = res.data.data
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
          setTimeout(() => {
            loading.close()
          }, 300)
        })
        .catch(() => {
          loading.close()
        })
    },
    czClick(row) {
      //点击充值
      this.CustomerfillingDig = true
      var str = JSON.stringify(row)
      this.cusUpdateObj = JSON.parse(str)
      // this.RechargetypeValue = "银行卡"
      this.CZTypeQuery()
    },
    innerVisibleClick() {
      if (this.RechargetypeValue == '')
        return this.$message.error('请选择充值类型')
      if (this.wayTypeValue == '') return this.$message.error('请选择变动方式')
      if (this.CZmoney <= 0) return this.$message.error('请输入充值金额')

      if (!this.CZremark) {
        this.$message.error('请填写备注')
      } else {
        this.innerVisible = true
      }
    },
    CZserve() {
      var url = '/orm/ormtb411/cz'
      var loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = {
        ORMTB410ID: this.cusUpdateObj.ORMTB410ID,
        ORMTB420CA01: this.wayTypeValue,
        ORMTB420CA02: this.CZmoney,
        ORMTB420CB01: this.CZremark,
        ORMTB411CA04: this.RechargetypeValue,
      }
      this.axios
        .post(url, postData)
        .then(res => {
          // console.log(res)
          if (res.data.code == 200) {
            this.$message.success('充值成功')
            this.querycusList()
            this.CustomerfillingDig = false
            this.innerVisible = false
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
          setTimeout(() => {
            loading.close()
          }, 300)
        })
        .catch(() => {
          loading.close()
        })
    },
    HCclick(row) {
      //点击红冲
      var str = JSON.stringify(row)
      this.cusUpdateObj = JSON.parse(str)
      this.HCshow = true
    },

    HCserve() {
      if (!this.HCmoney) return this.$message.error('请输入红冲金额')
      if (!this.HCremark) return this.$message.error('请输入备注')
      // if (this.HCmoney > this.cusUpdateObj.ORMTB410CA03) return this.$message.error('红冲金额不可大于余额');
      var url = '/orm/ormtb411/hc'
      var loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = {
        ORMTB410ID: this.cusUpdateObj.ORMTB410ID,
        ORMTB420CA02: this.HCmoney,
        ORMTB420CA08: this.HCremark,
        type: this.hczhlxValue
      }
      this.axios
        .post(url, postData)
        .then(res => {
          // console.log(res)
          if (res.data.code == 200) {
            this.$message.success(`红冲成功`)
            this.HCshow = false
            this.querycusList()
            this.HCremark = ''
            this.HCmoney = ''
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
          setTimeout(() => {
            loading.close()
          }, 300)
        })
        .catch(() => {
          loading.close()
        })
    },
    upuserClick(row) {
      if (this.preferentialType == 1) {
        this.customerManagementQuery()
      }
      this.cusUpdateShow = true
      var str = JSON.stringify(row)
      this.cusUpdateObj = JSON.parse(str)
    },
    upDJSetuserClick(row) {
      this.cusUDJSetpdateShow = true
      var str = JSON.stringify(row)
      this.cusDJSetObj = JSON.parse(str)
      // console.log(this.cusDJSetObj)
    },
    yhSetuserClick(row) {
      // console.log(row)
      this.yhInsertShow = true
      this.useryhmsg = row
      this.rowkhId = row.ORMTB410ID
      this.cjkhyhset(row.ORMTB410ID)
    },
    fdFun(row) {
      this.yhCjShow = true
      this.useryhmsg = row
      this.changjiaList()
      this.fdObj.khName = row.ORMTB410CA10
      this.fdObj.khId = row.ORMTB410ID
    },
    cjkhyhset(data) {
      var url = '/set/settb414/list'
      var loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = {
        ORMTB410ID: data,
      }
      this.axios
        .post(url, postData)
        .then(res => {
          // console.log(res)
          if (res.data.code == 200) {
            // console.log(res)
            this.tableDatayh = res.data.data
            this.selectData()
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
          setTimeout(() => {
            loading.close()
          }, 300)
        })
        .catch(() => {
          loading.close()
        })
    },
    cusADD() {
      if (this.preferentialType == 1) {
        this.customerManagementQuery()
      }
      this.cusInsertShow = true
    },
    cusUpdateServe() {
      if (this.cusUpdateObj.ORMTB410CA00.trim().length == 0)
        return this.$message.error('请输入客户名称')
      var reQ = /^1[3-9][0-9]{9}$/
      if (!reQ.test(this.cusUpdateObj.ORMTB410CA02))
        return this.$message.error('请输入有效手机号')
      if (this.preferentialType == 1) {
        if (this.cusUpdateObj.ORMTB410CA06.length == 0) {
          return this.$message.error('请选择客户等级')
        }
      }
      var url = '/orm/ormtb410/updateOrmtb410ById'
      var loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = this.cusUpdateObj
      this.axios
        .post(url, postData)
        .then(res => {
          // console.log(res)
          if (res.data.code == 200) {
            this.$message.success('修改成功')
            this.querycusList()
            this.cusUpdateShow = false
            this.cusUpdateObj = {
              ORMTB400ID: '',
              ORMTB410CA00: '',
              ORMTB410CA01: '',
              ORMTB410CA02: '',
              ORMTB410CA06: '',
            }
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
          setTimeout(() => {
            loading.close()
          }, 300)
        })
        .catch(() => {
          loading.close()
        })
    },
    cusDJSetdateServe() {
      if (!this.cusDJSetObj.ORMTB410CB41)
        return this.$message.error('请输入保底冻结金额')
      if (!this.cusDJSetObj.ORMTB410CB07)
        return this.$message.error('请输入冻结倍数')

      var url = '/orm/ormtb410/updateORMTB410CB07'
      var loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })

      var postData = {
        ORMTB410ID: this.cusDJSetObj.ORMTB410ID,
        ORMTB410CB07: this.cusDJSetObj.ORMTB410CB07,
        ORMTB410CB41: this.cusDJSetObj.ORMTB410CB41
      }
      this.axios
        .post(url, postData)
        .then(res => {
          // console.log(res)
          if (res.data.code == 200) {
            this.$message.success('设置成功')
            this.querycusList()
            this.cusUDJSetpdateShow = false
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
          setTimeout(() => {
            loading.close()
          }, 300)
        })
        .catch(() => {
          loading.close()
        })
    },
    rechargeTypeModify(row) {
      this.rechargeTypeModifyDig = true
      var str = JSON.stringify(row)
      this.rechargeTypeUpOBJ = JSON.parse(str)
    },
    disableCus(row, type) {
      var str = type == 1 ? '启用' : '禁用'
      this.$confirm(`此操作将${str}该条数据, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        var url = '/orm/ormtb410/updataCzType'
        var loading = this.$loading({
          lock: true,
          text: '请求中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.5)',
        })
        // console.log(this.userobj)
        var postData = {
          SETTB206CA01: '',
          SETTB206ID: row.SETTB206ID,
          SETTB206CA02: type,
        }
        this.axios
          .post(url, postData)
          .then(res => {
            // console.log(res)
            if (res.data.code == 200) {
              this.$message.success(`${str}成功`)
              this.queryWayTypeQuery()
            } else {
              this.$message({
                message: res.data.message,
                type: 'error',
              })
            }
            setTimeout(() => {
              loading.close()
            }, 300)
          })
          .catch(() => {
            loading.close()
          })
      })
    },
    rechargeTypeAdd() {
      this.rechargeTypeDig = true
    },
    rechargeTypeModifyClose() {
      this.rechargeTypeUpOBJ = {
        SETTB206CA01: '',
      }
    },
    querypreferentialCode() {
      var url = '/set/settb206/selectSETTB206List '
      var loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = {
        SETTB205ID: '02', //默认02
        SETTB206CA00: '0202', //代码值默认0202
        SETTB206CD01: this.userobj.ormtb400.ORMTB400CA03, //一级客户代码
      }
      this.axios
        .post(url, postData)
        .then(res => {
          // console.log(res)
          if (res.data.code == 200) {
            this.preferentialType = res.data.data[0].SETTB206CA02
            // 	loading.close()
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
          setTimeout(() => {
            loading.close()
          }, 300)
        })
        .catch(() => {
          loading.close()
        })
    },
    customerManagementQuery() {
      this.customerManagementList = []
      var url =
        '/set/settb206/selectPerson/' + this.userobj.ormtb400.ORMTB400CA03
      var loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      this.axios
        .get(url)
        .then(res => {
          // console.log(res)
          if (res.data.code == 200) {
            this.customerManagementList = res.data.data
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
          setTimeout(() => {
            loading.close()
          }, 300)
        })
        .catch(() => {
          loading.close()
        })
    },
    customerManagementAddServe() {
      if (this.customerManagementAddName.trim().length == 0)
        return this.$message.error('请输入名称')
      var url = '/set/settb206/insertVIP '
      var loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      // console.log(this.userobj)
      var postData = {
        SETTB206CA01: this.customerManagementAddName,
        SETTB206CD01: this.userobj.ormtb400.ORMTB400CA03,
        ORMTB400ID: this.userobj.ormtb400.ORMTB400ID,
      }
      this.axios
        .post(url, postData)
        .then(res => {
          // console.log(res)
          if (res.data.code == 200) {
            this.$message.success('新增成功')
            this.customerManagementQuery()
            this.customerManagementAdd = false
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
          setTimeout(() => {
            loading.close()
          }, 300)
        })
        .catch(() => {
          loading.close()
        })
    },
    cusUpdataClick(row) {
      this.customerManagemenUPObj = row
      this.customerManagemenUPObj.oldname = row.SETTB206CA01
      this.customerManagementUpdate = true
    },
    customerManagementUpdateServe() {
      if (
        this.customerManagemenUPObj.oldname ==
        this.customerManagemenUPObj.SETTB206CA01
      )
        return this.$message.error('请修改名称')
      if (this.customerManagemenUPObj.SETTB206CA01.trim().length == 0)
        return this.$message.error('请输入名称')
      var url = '/set/settb206/updateVIP'
      var loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = {
        SETTB206CA01: this.customerManagemenUPObj.SETTB206CA01,
        SETTB206ID: this.customerManagemenUPObj.SETTB206ID,
      }
      this.axios
        .post(url, postData)
        .then(res => {
          // console.log(res)
          if (res.data.code == 200) {
            this.$message.success('修改成功')
            this.customerManagementQuery()
            this.customerManagementUpdate = false
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
          setTimeout(() => {
            loading.close()
          }, 300)
        })
        .catch(() => {
          loading.close()
        })
    },
    rechaTypePreser() {
      if (this.rechargeTypeName.trim().length == 0)
        return this.$message.error('请输入名称')
      var url = '/orm/ormtb410/addCzType'
      var loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      // console.log(this.userobj)
      var postData = {
        SETTB206CA01: this.rechargeTypeName,
        SETTB206CD01: this.userobj.ormtb400.ORMTB400CA03,
      }
      this.axios
        .post(url, postData)
        .then(res => {
          // console.log(res)
          if (res.data.code == 200) {
            this.$message.success('新增成功')
            this.queryWayTypeQuery()
            this.rechargeTypeDig = false
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
          setTimeout(() => {
            loading.close()
          }, 300)
        })
        .catch(() => {
          loading.close()
        })
    },
    rechaTypePreserModify() {
      if (this.rechargeTypeUpOBJ.SETTB206CA01.trim().length == 0)
        return this.$message.error('请输入名称')
      var url = '/orm/ormtb410/updataCzType'
      var loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      // console.log(this.userobj)
      var postData = {
        SETTB206CA01: this.rechargeTypeUpOBJ.SETTB206CA01,
        SETTB206ID: this.rechargeTypeUpOBJ.SETTB206ID,
        SETTB206CA02: this.rechargeTypeUpOBJ.SETTB206CA02,
        SETTB206CD01: this.userobj.ormtb400.ORMTB400CA03,
      }
      this.axios
        .post(url, postData)
        .then(res => {
          // console.log(res)
          if (res.data.code == 200) {
            this.$message.success('修改成功')
            this.queryWayTypeQuery()
            this.rechargeTypeModifyDig = false
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
          setTimeout(() => {
            loading.close()
          }, 300)
        })
        .catch(() => {
          loading.close()
        })
    },
    DetailsWaterClick(item) {
      // console.log(item)
      if (!item.ORMTB440CA00) {
        this.$message({
          message: '未查询到订单',
          type: 'error',
        })
        return
      }
      this.DetailsWater = true
      this.deductionRecordDetileQuery(item)
    },
    deductionRecordDetileQuery(row) {
      this.deductionRecordObj = ''
      this.DetailsWatersrcList = []
      this.DetailsWaterurl = ''
      var url = '/orm/ormtb440/selectDetails'
      var loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      // console.log(this.userobj)
      var postData = {
        ORMTB440ID: row.ORMTB413CA03,
      }
      this.axios
        .post(url, postData)
        .then(res => {
          // console.log(res)
          if (res.data.code == 200) {
            this.deductionRecordObj = res.data.data
            this.DetailsWatersrcList = [this.deductionRecordObj.ORMTB440CE01]
            this.DetailsWaterurl = this.deductionRecordObj.ORMTB440CE01
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
          setTimeout(() => {
            loading.close()
          }, 300)
        })
        .catch(() => {
          loading.close()
        })
    },
    CZRecordsSizeChange(val) {
      this.pagesize = val
      this.page = 1
      this.CZrecordQuery()
    },
    CZRecordsCurrentChange(val) {
      this.page = val
      this.CZrecordQuery()
    },

    HCMoneyInput() {
      this.HCmoney = this.HCmoney.replace(/[^\d.]/g, '') //清除“数字”和“.”以外的字符
      this.HCmoney = this.HCmoney.replace(/^\./g, '') //验证第一个字符是数字
      this.HCmoney = this.HCmoney.replace(/\.{2,}/g, '.') //只保留第一个. 清除多余的
      this.HCmoney = this.HCmoney.replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.')
      this.HCmoney = this.HCmoney.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') //只能输入两个小数
      if (this.HCmoney.indexOf('.') < 0 && this.HCmoney != '') {
        //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        this.HCmoney = parseFloat(this.HCmoney)
      }
      this.HCmoney = this.HCmoney > 10000000 ? 10000000 : this.HCmoney
      // this.$refs.HCmoney.value = this.HCmoney
      this.HCamountCapitalText = this.priceChange(this.HCmoney)
    },
    HCMoneyChange() {
      var index = String(this.HCmoney).indexOf('.')
      if (index == -1) return
      var numArr = this.HCmoney.split('.')
      if (numArr[1].length == 0) {
        this.$refs.HCmoney.value = numArr[0]
        this.HCmoney = numArr[0]
      } else {
        this.$refs.HCmoney.value = numArr[0] + '.' + numArr[1]
        this.HCmoney = numArr[0] + '.' + numArr[1]
      }
    },
    topMoneyInput() {
      //充值金额实时校验
      // console.log(this.CZmoney)
      this.CZmoney = this.CZmoney.replace(/[^\d.]/g, '') //清除“数字”和“.”以外的字符
      this.CZmoney = this.CZmoney.replace(/^\./g, '') //验证第一个字符是数字
      this.CZmoney = this.CZmoney.replace(/\.{2,}/g, '.') //只保留第一个. 清除多余的
      this.CZmoney = this.CZmoney.replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.')
      this.CZmoney = this.CZmoney.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') //只能输入两个小数
      if (this.CZmoney.indexOf('.') < 0 && this.CZmoney != '') {
        //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        this.CZmoney = parseFloat(this.CZmoney)
      }
      this.CZmoney = this.CZmoney > 10000000 ? 10000000 : this.CZmoney
      // this.$refs.topMoney.value = this.CZmoney
      this.amountCapitalText = this.priceChange(this.CZmoney)
    },
    priceChange(number) {
      var ret = ''
      if (number != '' && number != null && number != '0') {
        var unit = '仟佰拾亿仟佰拾万仟佰拾元角分',
          str = ''
        number += '00'
        var point = number.indexOf('.')
        if (point >= 0) {
          number = number.substring(0, point) + number.substr(point + 1, 2)
        }
        unit = unit.substr(unit.length - number.length)
        for (var i = 0; i < number.length; i++) {
          str +=
            '零壹贰叁肆伍陆柒捌玖'.charAt(number.charAt(i)) + unit.charAt(i)
        }
        ret = str
          .replace(/零(仟|佰|拾|角)/g, '零')
          .replace(/(零)+/g, '零')
          .replace(/零(万|亿|元)/g, '$1')
          .replace(/(亿)万|(拾)/g, '$1$2')
          .replace(/^元零?|零分/g, '')
          .replace(/元$/g, '元')
      }
      return ret
    },
    topMoneyChange() {
      //充值金额失去焦点数据处理
      var index = String(this.CZmoney).indexOf('.')
      if (index == -1) return
      var numArr = this.CZmoney.split('.')
      if (numArr[1].length == 0) {
        this.$refs.topMoney.value = numArr[0]
        this.CZmoney = numArr[0]
      } else {
        this.$refs.topMoney.value = numArr[0] + '.' + numArr[1]
        this.CZmoney = numArr[0] + '.' + numArr[1]
      }
    },
    changjiaList(data) {
      var url = '/set/settb100/selectSettb100ByCa02'
      var loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = {
        ORMTB400ID: this.userobj.ormtb400.ORMTB400ID,
        type: 1,
      }
      this.axios
        .post(url, postData)
        .then(res => {
          // console.log(res)
          if (res.data.code == 200) {
            console.log(res)
            this.cjList = res.data.data
            //this.selectData()
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
          setTimeout(() => {
            loading.close()
          }, 300)
        })
        .catch(() => {
          loading.close()
        })
    },
    openWuliaoClick(row) {
      this.wuliaoShow = true
      this.fdcjmsgobj = row
      this.fdObj.khId = row.ORMTB410ID
      this.fdObj.khName = row.ORMTB410CA00
      this.changjiaList()
      this.fdListFun()
      //查询返点列表
    },

    /* 含税价设置START */

    selectwlhxPageListFun() {
      //根据厂家获取物料含税价和不含税价信息
      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = {
        SETTB99ID: this.fdObj.cjId,
        ORMTB410ID: this.objuserMsg.ORMTB410ID,
        limit: this.hsjListlimitMaterial,
        page: this.hsjListpageMaterial,
      }
      this.materList = []
      var fdmoList
      var url = 'set/settb109/selectwlhxPageList'
      this.axios
        .post(url, postData)
        .then(res => {
          console.log(res)
          setTimeout(() => {
            loading.close()
          }, 300)
          if (res.data.code == 200) {
            fdmoList = res.data.data.list
            this.fdmaterList = fdmoList
            this.hsjListpagingPageMaterial = res.data.count

            if (res.data.data.taxSwitch == 0) {
              this.hanshuijiaKG = false
              this.hsjstus = 0
            } else {
              this.hanshuijiaKG = true
              this.hsjstus = 1
            }
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },

    ykhsjChangJiaFun() {
      //查询已开启含税价厂家
      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = {
        ORMTB703CA00: this.objuserMsg.ORMTB410ID,
      }
      this.materList = []
      var fdmoList
      var url = 'orm/ormtb703/selectList'
      this.axios
        .post(url, postData)
        .then(res => {
          // console.log(res)
          setTimeout(() => {
            loading.close()
          }, 300)
          if (res.data.code == 200) {
            console.log(res)
            this.ykhsjcjList = res.data.data
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },

    openhanshuijiaClick(row) {
      //点击打开含税价设置弹窗
      console.log(row)
      this.hanshuijiaShow = true
      this.objuserMsg = row
      // if (this.objuserMsg.ORMTB410CB23 == 1) {
      // 	this.hanshuijiaKG = true
      // 	// this.hsjstus =1
      // }
      // else{
      // 	this.hanshuijiaKG = false
      // 	this.hsjstus =0
      // }
      this.changjiaList()
      this.ykhsjChangJiaFun()
    },

    hanshuijiaKGFun() {
      //含税价开关
      console.log(this.fdObj.cjId)
      if (this.fdObj.cjId == '') {
        this.$message.error('请选择厂家')
        this.hanshuijiaKG = false
      }
      if (this.hanshuijiaKG == false) {
        this.hsjstus = 0
      }
      if (this.hanshuijiaKG == true) {
        this.hsjstus = 1
      }
      console.log(this.hanshuijiaKG)
    },

    hsjszCloFun() {
      this.hanshuijiaShow = false
      this.hanshuijiaKG = false
      this.fdmaterList = []
      this.fdObj.cjId = ''
    },

    hsjyhserve() {
      //提交含税价设置信息

      console.log(this.objuserMsg)
      console.log(this.fdObj)

      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = {
        ORMTB703CA00: this.objuserMsg.ORMTB410ID, //用户ID
        ORMTB703CA01: this.objuserMsg.ORMTB410CA00, //用户name
        ORMTB703CA02: this.fdObj.cjId, //厂家ID
        ORMTB703CA04: this.hsjstus, //含税价开关状态
      }

      var url = 'orm/ormtb703/changeTaX'
      this.axios
        .post(url, postData)
        .then(res => {
          // console.log(res)
          setTimeout(() => {
            loading.close()
          }, 300)
          if (res.data.code == 200) {
            console.log(res)
            this.$message({
              message: res.data.message,
              type: 'success',
            })
            this.hsjszCloFun()
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },

    hsjhandleSizeChangeMaterial(val) {
      this.hsjpageMaterial = 1
      this.hsjListlimitMaterial = val
      this.selectwlhxPageListFun()
    },
    // 点击页码
    hsjhandleCurrentChangeMaterial(val) {
      this.hsjpageMaterial = val
      this.selectwlhxPageListFun()
    },

    /* 含税价设置END */

    /*根据厂家查物料*/
    fdPageMaterialList() {
      //this.fdObj.wlName = ""

      if (this.hanshuijiaShow == true) {
        //查看厂家物料含税价和不含税价

        console.log(this.objuserMsg)

        this.selectwlhxPageListFun()
      } else {
        this.fdObj.wlId = ''
        console.log(JSON.stringify(this.uobj))
        let loading = this.$loading({
          lock: true,
          text: '请求中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.5)',
        })
        var postData = {
          SETTB99ID: this.fdObj.cjId,
          SETTB109CD01: '',
          limit: '1000',
          page: '1',
        }
        this.materList = []
        var fdmoList
        var url = 'set/settb109/selectPageList'
        this.axios
          .post(url, postData)
          .then(res => {
            // console.log(res)
            setTimeout(() => {
              loading.close()
            }, 300)
            if (res.data.code == 200) {
              fdmoList = res.data.data
              this.fdmaterList = fdmoList
              this.fdpagingPageMaterial = res.data.count
            } else {
              this.$message({
                message: res.data.message,
                type: 'error',
              })
            }
          })
          .catch(() => {
            loading.close()
          })
        this.onSelecteLableCj()
      }
    },
    /*返点调控修改*/
    fandianModify(item) {
      this.fandianShow = true
      this.fdObj.cjName = item.SETTB420CA00
      this.fdObj.cjId = item.SETTB420CA01
      this.fdObj.fdbl = item.SETTB420CA07
      this.fdObj.startTime = item.SETTB420CA09
      this.fdObj.endTime = item.SETTB420CA10
      //获取物料下拉列表
      this.fdPageMaterialList()
      //选中
      this.fdObj.wlId = item.SETTB420CA03
      this.fdObj.wlName = item.SETTB420CA02
    },
    /*返点调控新增*/
    fandianAdd() {
      this.fandianShow = true
      //清空表单
      this.fdObj.cjName = ''
      this.fdObj.cjId = ''
      this.fdObj.wlName = ''
      this.fdObj.wlId = ''
      this.fdObj.fdbl = ''
      this.fdObj.startTime = ''
      this.fdObj.endTime = ''
      this.fdmaterList = []
      this.fdObj.wls = []
      this.fdObj.wlobjs = []
    },
    commitFdModify() {
      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = {
        SETTB420CA00: this.fdObj.cjName,
        SETTB420CA01: this.fdObj.cjId,
        SETTB420CA02: this.fdObj.wlName,
        SETTB420CA03: this.fdObj.wlId,
        SETTB420CA04: this.fdObj.khName,
        SETTB420CA05: this.fdObj.khId,
        SETTB420CA07: this.fdObj.fdbl,
        SETTB420CA09: this.dateFtt(
          'yyyy-MM-dd hh:mm:ss',
          new Date(this.fdObj.startTime)
        ),
        SETTB420CA10: this.dateFtt(
          'yyyy-MM-dd hh:mm:ss',
          new Date(this.fdObj.endTime)
        ),
        WLOBJS: this.fdObj.wlobjs,
      }
      var url = 'set/settb420/save'
      this.axios
        .post(url, postData)
        .then(res => {
          if (res.data.code == 200) {
            this.fandianShow = false
            this.fdListFun()
            this.$message({
              message: '保存成功',
              type: 'success',
            })
          } else {
            this.$message({
              message: '保存失败',
              type: 'error',
            })
            this.fandianShow = false
          }
          setTimeout(() => {
            loading.close()
          }, 300)
        })
        .catch(() => {
          loading.close()
        })
    },
    commitVerify() {
      if (this.fdObj.cjName.trim().length == 0)
        return this.$message.error('请选择厂家')
      if (this.fdObj.fdbl.toString().trim().length == 0)
        return this.$message.error('请输入返点比率')
      if (this.fdObj.startTime.length === 0)
        return this.$message.error('请选择开始时间')
      if (this.fdObj.endTime.length === 0)
        return this.$message.error('请选择结束时间')
      if (!/^-?\d+(\.\d+)?$/.test(this.fdObj.fdbl)) {
        return this.$message.error('请输入有效的返点比率')
      }
      if (this.fdObj.startTime >= this.fdObj.endTime) {
        return this.$message.error('结束时间需大于开始时间')
      }
      if (this.fdObj.wlobjs.length == 0) {
        this.$confirm('不选择物料将对所有物料进行设置, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.commitFdModify()
          })
          .catch(() => { })
      } else {
        this.commitFdModify()
      }
    },
    fdhandleSizeChangeMaterial(val) {
      this.fdpageMaterial = 1
      this.fdlimitMaterial = val
      this.fdListFun()
    },
    // 点击页码
    fdhandleCurrentChangeMaterial(val) {
      this.fdpageMaterial = val
      this.fdListFun()
    },
    /*返点列表*/
    fdListFun() {
      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = {
        SETTB420CA05: this.fdObj.khId,
        page: this.fdpageMaterial,
        limit: this.fdlimitMaterial,
      }
      var url = 'set/settb420/list'
      this.axios
        .post(url, postData)
        .then(res => {
          setTimeout(() => {
            loading.close()
          }, 300)
          if (res.data.code == 200) {
            this.fdList = res.data.data
            this.fdListpagingPageMaterial = res.data.count
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },
    onSelecteLable() {
      const idSet = new Set(this.fdObj.wls)
      this.fdObj.wlobjs = this.fdmaterList.filter(item =>
        idSet.has(item.SETTB109ID)
      )
    },
    onSelecteLableCj() {
      let obj = {}
      obj = this.cjList.find(item => {
        //这里的userList就是上面遍历的数据源
        return item.SETTB99ID === this.fdObj.cjId //筛选出匹配数据
      })
      this.fdObj.cjName = obj.SETTB99CA00
    },
    dateFtt(fmt, date) {
      //author: meizz
      var o = {
        'M+': date.getMonth() + 1, //月份
        'd+': date.getDate(), //日
        'h+': date.getHours(), //小时
        'm+': date.getMinutes(), //分
        's+': date.getSeconds(), //秒
        'q+': Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds(), //毫秒
      }
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + '').substr(4 - RegExp.$1.length)
        )
      for (var k in o)
        if (new RegExp('(' + k + ')').test(fmt))
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ('00' + o[k]).substr(('' + o[k]).length)
          )
      return fmt
    },
    deleteFd(item) {
      var postData = {
        SETTB420ID: item.SETTB420ID,
      }
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          let loading = this.$loading({
            lock: true,
            text: '请求中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.5)',
          })
          var url = 'set/settb420/delete'
          this.axios
            .post(url, postData)
            .then(res => {
              setTimeout(() => {
                loading.close()
              }, 300)
              if (res.data.code == 200) {
                this.fdListFun()
                this.$message({
                  type: 'success',
                  message: '删除成功!',
                })
              } else {
                this.$message({
                  message: res.data.message,
                  type: 'error',
                })
              }
            })
            .catch(() => {
              loading.close()
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    openWuliaoClickTj(row) {
      this.wuliaoShowTj = true
      this.fdObj.khId = row.ORMTB410ID
      this.fdListFunTj()
    },
    // 打开授权厂家弹窗
    openShouQuanChangJia(row) {
      this.customerId = row.ORMTB410ID
      this.checkedCitiesName = []
      this.checkedCitiesId = []
      this.factoryList = []
      this.isIndeterminateCj = false
      this.checkAllCj = false
      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = {
        ORMTB706CA00: row.ORMTB410ID,
      }
      var url = 'orm/ormtb706/selectSettb100ByCa02V2'
      this.axios
        .post(url, postData)
        .then(res => {
          setTimeout(() => {
            loading.close()
          }, 300)
          if (res.data.code == 200) {
            this.checkedCitiesName = res.data.data
              .filter(item => item.check == 1)
              .map(item => item.SETTB99CA00)
            this.checkedCitiesId = res.data.data
              .filter(item => item.check == 1)
              .map(item => item.SETTB99ID)
            this.factoryList = res.data.data
            this.checkAllCj =
              this.checkedCitiesName.length == this.factoryList.length
                ? true
                : false
            this.isIndeterminateCj =
              this.checkedCitiesName.length > 0 &&
              this.checkedCitiesName.length < this.factoryList.length
            this.shouQuanChangJiaShow = true
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },
    /*返点统计列表*/
    fdListFunTj() {
      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = {
        SETTB420CA05: this.fdObj.khId,
      }
      var url = 'set/settb420/count'
      this.axios
        .post(url, postData)
        .then(res => {
          setTimeout(() => {
            loading.close()
          }, 300)
          if (res.data.code == 200) {
            this.fdListTj = res.data.data
            this.fdListpagingPageMaterialTj = res.data.count
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },
    fdhandleSizeChangeMaterialTj(val) {
      this.fdpageMaterialTj = 1
      this.fdlimitMaterialTj = val
      this.fdListFunTj()
    },
    // 点击页码
    fdhandleCurrentChangeMaterialTj(val) {
      this.fdpageMaterialTj = val
      this.fdListFunTj()
    },
    clearFunWl() {
      this.fdObj.wlId = ''
      this.fdObj.wlName = ''
    },
  },
}
</script>

<style scoped>
.carDialogTitle {
  font-weight: bold;
  line-height: 60px;
  color: rgb(0, 163, 255);
}

.customerManagementPC {
  background-color: #f3f3f3;
}

.DWD-li {
  display: flex;
  height: 35px;
  line-height: 35px;
  box-sizing: border-box;
  border: 1px solid #999;
  font-size: 16px;
  color: #333;
}

.DWD-li>div {
  padding: 0 5px;
  height: 34px;
  overflow: hidden;
  box-sizing: border-box;
}

.DWD-li-title {
  width: 100px;
  text-align: center;
  border-right: 1px solid #999;
  background-color: rgba(0, 163, 255, 0.1);
}

.DWD-li+.DWD-li {
  border-top: none;
}

.DWD-table {
  display: flex;
}

.DWD-table-left-flex {
  flex: 1;
}

.DWD-table>div>div {
  padding: 0 5px;
  height: 35px;
  line-height: 35px;
  overflow: hidden;
  text-align: center;
  border-right: 1px solid #999;
  border-bottom: 1px solid #999;
  box-sizing: border-box;
}

.DWD-table>div>div:first-child {
  background-color: rgba(0, 163, 255, 0.1);
}

.DWD-table-left-title>div {
  width: 101px;
  text-align: center;
  background-color: rgba(0, 163, 255, 0.1);
}

.DWD-table .DWD-table-left-title>div {
  padding: 0 5px;
  height: 35px;
  line-height: 35px;
  overflow: hidden;
  box-sizing: border-box;
  border-left: 1px solid #999;
  border-bottom: 1px solid #999;
}

.DetailsWater-img {
  margin-top: 30px;
}

.DetailsWater-img-text {
  display: inline-block;
  width: 101px;
  text-align: center;
  vertical-align: top;
}

.customerManagementPC-select .public_oparetionBlock_Menu:first-child {
  margin-left: 0;
}

.customerManagementPC-btn {
  text-align: left;
  margin-bottom: 20px;
}

.customerManagementPC-btn i {
  margin-right: 10px;
}

.customerManagementPC-table {
  padding: 30px 20px 0;
}

.customerManagementPC-table-btn i {
  font-size: 12px;
  margin-right: 5px;
}

.customerManagementPC-add-customer {
  padding-left: 20px;
}

.customerManagementPC-add-customer-li {
  display: flex;
  text-align: center;
  font-size: 16px;
  height: 42px;
  line-height: 42px;
}

.customerManagementPC-add-customer-li>div {
  border: 1px solid #cdcdcd;
  border-top: none;
}

.customerManagementPC-add-customer-li:first-child>div {
  border-top: 1px solid #cdcdcd;
}

.customerManagementPC-add-customer-li>div:first-child {
  border-right: none;
}

.customerManagementPC-add-customer-li>div:last-child {
  border: none;
  color: #ff4d35;
}

.customerManagementPC-add-customer-li-name {
  flex: 1;
}

.customerManagementPC-add-customer-li-ipt {
  flex: 1;
  box-sizing: border-box;
}

.customerManagementPC-add-customer-li-ipt input {
  border: none;
  outline: none;
  width: 100%;
  height: 37px;
  box-sizing: border-box;
  vertical-align: top;
  padding-left: 5px;
  text-align: center;
  font-size: 16px;
}

.customerManagementPC-add-customer-li-type {
  flex: 0.3;
}

.customerManagementPC-add-customer-btn {
  text-align: center;
  margin: 30px 0 20px 0;
}

.public-chech-details-table {
  margin-top: 20px;
  max-height: 500px;
  overflow-y: auto;
}

.public-chech-details-table-no-text {
  line-height: 80px;
  text-align: center;
  border-bottom: 1px solid #cdcdcd;
}

.customerManagementPC-page {
  margin-top: 20px;
  text-align: right;
}

.CustomerfillingDig-priceNumtext {
  font-weight: 500;
  font-size: 18px;
  line-height: 40px;
  padding: 20px 0 20px 10px;
  color: #333;
}

.CustomerfillingDig-priceNumtext span {
  color: rgba(175, 181, 4, 1);
  margin-left: 10px;
  font-size: 20px;
}

.fontBlue {
  color: rgba(25, 159, 255, 1) !important;
}

.billOperationRecord {
  background-color: #f3f3f3;
}

.billOperationRecord-border {
  /* border-top: 2px solid rgba(205,205,205,.4); */
  border-top: none;
  box-sizing: border-box;
  margin-right: 40px;
}

.billOperationRecord th,
.billOperationRecord td {
  text-align: center;
}

.customerRecharge-table {
  box-sizing: border-box;
}

.CustomertopUpDig-content-table-btn>.public_saleWater_lieSet {
  border-color: rgba(254, 172, 0, 1) !important;
}

.CustomerfillingDig-tab {
  padding-left: 20px;
}

.CustomerfillingDig-tab-li,
.rechargeType-tab-li {
  display: flex;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 16px;
  color: #333;
  vertical-align: top;
}

.CustomerfillingDig-tab-li>div {
  border: 1px solid #cdcdcd;
  border-top: none;
}

.CustomerfillingDig-tab-li>div:first-child {
  border-right: none;
}

.CustomerfillingDig-tab-li:first-child>div {
  border-top: 1px solid #cdcdcd;
}

.CustomerfillingDig-tab-li>div:last-child,
.rechargeType-tab-li>div:last-child {
  border: none;
  color: #ff4d35;
}

.CustomerfillingDig-tab-li-text {
  flex: 0.8;
  background: rgba(240, 252, 255, 1);
}

.CustomerfillingDig-tab-li-ipt {
  flex: 0.8;
}

.rechargeType-tab-li-text {
  flex: 0.35;
}

.rechargeType-tab-li-ipt {
  flex: 0.7;
}

.CustomerfillingDig-tab-li-ipt input,
.rechargeType-tab-li-ipt input {
  height: 46px;
  width: 100%;

  text-align: center;

  box-sizing: border-box;
  font-size: 16px;
  color: #333;
}

.CustomerfillingDig-tab-li-ipt input {
  outline: none;
  border: none;
  vertical-align: top;
}

.rechargeType-tab-li-ipt input {
  /* border-radius: 8px; */
  /* outline: none; */
}

.CustomerfillingDig-tab-li-b,
.rechargeType-tab-li-b {
  flex: 0.3;
}

.CustomerfillingDig-tab-btn {
  text-align: center;
  margin-top: 30px;
}

.rechargeType-tab-btn {
  margin-top: 80px !important;
}

.billOperationRecord-page {
  padding-right: 40px;
  text-align: right;
  margin-top: 20px;
  padding-bottom: 20px;
}

.salesWatersStatisticsPC-saleWaterDetails-btn {
  margin-bottom: 20px;
}

.salesWatersStatisticsPC-saleWaterDetails-btn i {
  margin-right: 10px;
}

.el-dropdown-link {
  cursor: pointer;
}

.el-table--scrollable-y .el-table__body-wrapper {
  overflow: auto;
}

.public_tableColumn .el-table__body-wrapper {
  overflow: auto !important;
}

.public_icon_width {
  width: 80px;
}

.levelmang-title {
  display: flex;
  color: #333;
  text-align: center;
  margin-bottom: 20px;
}

.levelmang-title div {
  padding: 10px 20px;
  background-color: #e3e3e3;
}

.levelmang-title .levelmang-title-active {
  background-color: #199fff;
  color: #fff;
}

.levelmang-table {
  border: 1px solid #e3e3e3;
}

.levelmang-table>li {
  display: flex;
}

.levelmang-table-head {
  text-align: center;
  background-color: #30a8ff;
  color: #fff;
}

.levelmang-table-head>div {
  height: 50px;
  line-height: 50px;
  border-left: 1px solid #e3e3e3;
  box-sizing: border-box;
  overflow: hidden;
}

.levelmang-table-head>div:first-child {
  border: none;
}

.levelmang-table-CQ {
  flex: 1;
  position: relative;
  padding: 5px 10px;
}

.levelmang-table-CQ-list {
  border-bottom: 1px solid #e3e3e3;
}

.levelmang-table-JB {
  width: 240px;
}

.levelmang-table-KJ,
.levelmang-table-ZK,
.levelmang-table-YH {
  width: 295px;
}

.levelmang-table-ZK input,
.levelmang-table-YH input {
  text-align: center;
}

.levelmang-table-li {
  text-align: center;
}

.levelmang-table-li-tab-li {
  border-bottom: 1px solid #e3e3e3;
}

.levelmang-table-li-tab-li:last-child {
  /* border: none; */
}

.levelmang-table-li-tab-li>div {
  border-left: 1px solid #e3e3e3;
  padding: 0 10px;
  box-sizing: border-box;
  height: 50px;
  line-height: 50px;
  vertical-align: top;
  overflow: hidden;
}

.levelmang-table-li-tab-li>div>input {
  width: 100px;
  border: 1px solid #e3e3e3;
  height: 35px;
  line-height: 35px;
  border-radius: 5px;
  margin-right: 10px;
}

.levelmang-table-CQ>div {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 100%;
  transform: translate(-50%, -50%);
}

.levelmang-table-li-tab-li {
  display: flex;
}

.systemCorporateAccount-dialog {
  padding: 0 20px;
}

.systemCorporateAccount-dialog-li {
  display: flex;
  box-sizing: border-box;
}

.systemCorporateAccount-dialog-li+.systemCorporateAccount-dialog-li {
  margin-top: 20px;
}

.systemCorporateAccount-dialog-btn {
  text-align: center;
  margin-top: 40px;
}

.systemCorporateAccount-wuliao-input>input {
  height: 40px;
  box-sizing: border-box;
  border: 1px solid #dcdfe6;
  border-radius: 5px;
  padding-left: 5px;
}

.SCADL-text {
  height: 30px;
  line-height: 30px;
  flex: 0.35;
  font-size: 18px;
  color: #333;
}

.SCADL-text span {
  color: red;
}

.SCADL-input {
  flex: 1;
  box-sizing: border-box;
}

.SCADL-input input {
  height: 40px;
  line-height: 30px;
  width: 99.9%;
  padding-left: 10px;
  border: 1px solid #999;
  color: #333;
  font-size: 18px;
  border-radius: 5px;
  box-sizing: border-box;
}

.SCADL-input .el-input {
  font-size: 18px;
}

.num {
  color: #333;
  font-size: 18px;
}

.cJ-btn {
  margin-top: 20px;
}

.shouQuanChangJia-dialog .el-checkbox {
  margin-bottom: 15px;
}

/deep/ .num .el-input .el-input__inner {
  font-size: 18px !important;
}

::v-deep .addPointer {
  cursor: pointer;
}

::v-deep .success-row {
  background-color: #81d3f8 !important;
}

.customerBillTable {
  display: flex;
}

.inputBox {
  width: 200px;
  border: 1px solid#DCDFE6;
  height: 33px;
  border-radius: 4px;
  padding: 0 10px;
  box-sizing: border-box;
}

.activeRed {
  display: inline-block;
  background-color: red;
  border-radius: 5px;
  padding: 4px;
  color: #fff;
}

.activeGreen {
  display: inline-block;
  background-color: green;
  border-radius: 5px;
  color: #fff;
  padding: 4px;
  box-sizing: border-box;
}

.textColor {
  color: red;
  padding-right: 60px;
  box-sizing: border-box;
}
</style>
